// NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
if (typeof window === 'undefined') {

    const _ = require('lodash');

    modulesMetrics(
        module.exports,
        _,
        require('underscore.string'),
        require('../enums/metrics.js'),
        require('../strings/strings.js'),
        require('./formatter.js'),
        _.extend({},
            baseRequire('models/metrics/socialPosts.js'),
            baseRequire('models/metrics/facebookInsightsPost.js'),
            baseRequire('models/metrics/discovery.js'),
            baseRequire('models/metrics/insights.js')
        ),
        require('./data/linkedInJobFunctions.js')
    );

} else {

    RivalIQ.module('metrics', function () {});

    modulesMetrics(
        RivalIQ.metrics,
        window._,
        window.s,
        RivalIQ.enums,
        RivalIQ.strings,
        RivalIQ.formatter,
        RivalIQ.models.metrics,
        RivalIQ.data.LinkedInJobFunctionMap
    );
}

function modulesMetrics(metrics, _, s, enums, strings, formatter, metricsModels, LinkedInJobFunctionMap) {

    'use strict';

    const dataType = enums.dataType;
    const metricType = enums.metricType;
    const category = enums.category;
    const source = enums.sources;
    const reachType = enums.reachType;

    const iconUrls = {};
    iconUrls[source.TWITTER] = '/images/twitter-bird-white-on-blue.png';
    iconUrls[source.FACEBOOK] = '/images/f_logo.png';
    iconUrls[source.FACEBOOK_INSIGHTS] = iconUrls[source.FACEBOOK];
    iconUrls[source.LINKEDIN] = '/images/linked_in_35px.png';
    iconUrls[source.WEB] = '/images/globe.png';
    iconUrls[source.RIVALIQ] = '/images/logo.png';
    iconUrls[source.CROSS_CHANNEL] = '/images/logo.png';
    iconUrls[source.YOUTUBE] = '/images/youtube.png';
    iconUrls[source.INSTAGRAM] = '/images/instagram.png';

    // TODO this should use sourceDetails but current load order
    // dependencies prevent that
    const sourceWords = {};
    sourceWords[source.TWITTER] = {
        interactionName: 'likes, replies, and retweets',
        postName: 'tweets'
    };
    sourceWords[source.FACEBOOK] = {
        interactionName: 'reactions, comments, and shares',
        postName: 'posts'
    };
    sourceWords[source.LINKEDIN] = {
        interactionName: 'likes, comments, shares, and clicks',
        postName: 'updates'
    };
    sourceWords[source.YOUTUBE] = {
        interactionName: 'likes and comments',
        postName: 'videos'
    };
    sourceWords[source.INSTAGRAM] = {
        interactionName: 'likes and comments',
        postName: 'posts'
    };

    const FACEBOOK_METRICS_SEED = 11000;
    const LINKED_IN_METRICS_SEED = 210000;
    let SOCIAL_POSTS_SEED = 230000;
    let FACEBOOK_INSIGHTS_POSTS_SEED = 250000;
    const INSTAGRAM_METRICS_SEED = 260000;
    let INSIGHTS_METRICS_SEED = 270000;

    function createChannelAddMetricDescription(seed, sourceName, source, trend, base) {

        return function (name, config) {

            if (base) {
                config = _.create(base, config);
            }

            const metricDescription = addMetricDescription(
                [sourceName, name].join('_'), source, config);

            const properties = {
                rollupSource: trend,
                activityFilter: {
                    include: false
                }
            };

            if (!_.isFinite(metricDescription.id)) {

                properties.id = seed;
                seed += 1;
            }

            const desc = _.defaults(metricDescription, properties);

            return desc;
        };
    }

    const addFacebookMetricDescription = createChannelAddMetricDescription(
        FACEBOOK_METRICS_SEED, 'FACEBOOK', source.FACEBOOK, 'facebookTrends');

    const addFacebookInsightsMetricDescription = function (name, config) {

        const options = _.defaults(config || {}, {
            source: source.FACEBOOK_INSIGHTS,
            rollupSource: 'facebookInsightsTrends'
        });

        return addFacebookMetricDescription(['INSIGHTS', name].join('_'), options);
    };

    const addInstagramMetricDescription = createChannelAddMetricDescription(
        INSTAGRAM_METRICS_SEED, 'INSTAGRAM', source.INSTAGRAM, 'instagramTrends');

    const addInstagramInsightsMetricDescription = function (name, config) {

        const options = _.defaults(config || {}, {
            source: source.INSTAGRAM_INSIGHTS,
            rollupSource: 'instagramInsightsTrends'
        });

        return addInstagramMetricDescription(['INSIGHTS', name].join('_'), options);
    };

    const addLinkedInMetricDescription = createChannelAddMetricDescription(
        LINKED_IN_METRICS_SEED, 'LINKED_IN', source.LINKEDIN, 'linkedInTrends');

    const metricDescriptions = {
        'TWITTER_FOLLOWERS': {
            'id': 10000,
            'source': source.TWITTER,
            'dataType': dataType.INTEGER,
            'category': category.REACH,
            'metricType': metricType.TOTAL,
            'name': 'Twitter Followers',
            'abbreviatedName': 'Followers',
            'description': strings.twitter_followers_description,
            'iconUrl': iconUrls[source.TWITTER],
            'activityFilter': {
                'include': true,
                'event': {
                    'up': {
                        'relative': 0.1,
                        'absolute': 100
                    },
                    'down': {
                        'relative': 0.1,
                        'absolute': 100
                    },
                    'ignoreZeros': true
                },
                'default': {
                    'up': {
                        'relative': 0.1,
                        'absolute': 100
                    },
                    'down': {
                        'relative': 0.1,
                        'absolute': 100
                    },
                    'ignoreZeros': true
                },
                'scaling': {
                    'up': {
                        'relative': 'standard',
                        'absolute': 'standard'
                    },
                    'down': {
                        'relative': 'standard',
                        'absolute': 'standard'
                    }
                }
            },
            'rollupSource': 'twitterTrends',
            'propSummary': 'audience',
            'propDaily': 'audience'
        },
        'TWITTER_PRESENCE_REACH': {
            'id': 10100,
            'source': source.TWITTER,
            'dataType': dataType.INTEGER,
            'category': category.REACH,
            'metricType': metricType.TOTAL,
            'name': 'Twitter Followers',
            'abbreviatedName': 'Followers',
            'description': strings.twitter_presence_reach_description,
            'iconUrl': iconUrls[source.TWITTER],
            'dontShowInUi': true,
            'rollupSource': 'twitterTrends',
            'propSummary': 'presence_reach',
            'propDaily': 'presence_reach'
        },
        'TWITTER_FOLLOWING': {
            'id': 10001,
            'source': source.TWITTER,
            'dataType': dataType.INTEGER,
            'category': category.REACH,
            'metricType': metricType.TOTAL,
            'name': 'Twitter Following',
            'abbreviatedName': 'Following',
            'description': strings.twitter_following_description,
            'iconUrl': iconUrls[source.TWITTER],

            'rollupSource': 'twitterTrends',
            'propSummary': 'following',
            'propDaily': 'following'
        },
        'TWITTER_ALL_TWEETS': {
            'id': 10002,
            'source': source.TWITTER,
            'dataType': dataType.INTEGER,
            'category': category.ACTIVITY,
            'metricType': metricType.VOLUME,
            'name': 'All Tweets',
            'exportName': 'All Tweet',
            'description': strings.twitter_all_tweets_description,
            'iconUrl': iconUrls[source.TWITTER],
            'submetrics': ['TWITTER_NORMAL_TWEETS', 'TWITTER_RETWEET_TWEETS', 'TWITTER_REPLY_TWEETS'],
            'rollupSource': 'twitterTrends',
            'propSummary': 'tweets',
            'propDaily': 'daily_tweets'
        },
        'TWITTER_AVERAGE_DAILY_TWEETS': {
            'id': 10102,
            'source': source.TWITTER,
            'dataType': dataType.NUMERIC,
            'category': category.ACTIVITY,
            'metricType': metricType.VOLUME,
            'name': 'Average of All Tweets per Day',
            'exportName': 'Average Daily All Tweet',
            'description': strings.twitter_average_daily_tweets_description,
            'iconUrl': iconUrls[source.TWITTER],
            'submetrics': ['TWITTER_AVERAGE_DAILY_NORMAL_TWEETS', 'TWITTER_AVERAGE_DAILY_RETWEET_TWEETS', 'TWITTER_AVERAGE_DAILY_REPLY_TWEETS'],
            'rollupSource': 'twitterTrends',
            'propSummary': 'average_daily_tweets',
            'propDaily': 'daily_tweets'
        },
        'TWITTER_TWEETS_RETWEETS': {
            'id': 10003,
            'source': source.TWITTER,
            'dataType': dataType.INTEGER,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Retweets',
            'exportName': 'Retweet',
            'shortName': 'Retweets',
            'description': strings.twitter_tweets_retweets_description,
            'iconUrl': iconUrls[source.TWITTER],
            'rollupSource': 'twitterTrends',
            'propSummary': 'retweets',
            'propDaily': 'daily_retweets'
        },
        'TWITTER_AVERAGE_DAILY_TWEETS_RETWEETS': {
            'id': 10103,
            'source': source.TWITTER,
            'dataType': dataType.NUMERIC,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Average Retweets per Day',
            'exportName': 'Average Daily Retweet',
            'description': strings.twitter_average_daily_tweets_retweets_description,
            'iconUrl': iconUrls[source.TWITTER],
            'rollupSource': 'twitterTrends',
            'propSummary': 'average_daily_retweets',
            'propDaily': 'daily_retweets'
        },
        'TWITTER_TWEETS_FAVORITES': {
            'id': 10004,
            'source': source.TWITTER,
            'dataType': dataType.INTEGER,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Likes of Company Tweets',
            'abbreviatedName': 'Likes',
            'shortName': 'Likes',
            'exportName': 'Likes of Company Tweet',
            description: strings.twitter_tweets_favorites_description,
            'iconUrl': iconUrls[source.TWITTER],
            'rollupSource': 'twitterTrends',
            'propSummary': 'favorites',
            'propDaily': 'daily_favorites'
        },
        'TWITTER_AVERAGE_DAILY_TWEETS_FAVORITES': {
            'id': 10104,
            'source': source.TWITTER,
            'dataType': dataType.NUMERIC,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Average Likes per Day',
            'exportName': 'Average Daily Like',
            description: strings.twitter_average_daily_tweets_favorites_description,
            'iconUrl': iconUrls[source.TWITTER],
            'rollupSource': 'twitterTrends',
            'propSummary': 'average_daily_favorites',
            'propDaily': 'daily_favorites'
        },
        'TWITTER_TWEETS_ENGAGEMENT_TOTAL': {
            'id': 10005,
            'source': source.TWITTER,
            'dataType': dataType.INTEGER,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Tweet Engagement Total',
            'abbreviatedName': 'Tweet Engagement Total',
            'exportName': 'Total Engagement for Tweets',
            description: strings.twitter_tweets_engagement_total_description,
            'iconUrl': iconUrls[source.TWITTER],
            'activityFilter': {
                'include': true,
                'event': {
                    'up': {
                        'relative': 5,
                        'absolute': 100
                    }
                },
                'default': {
                    'up': {
                        'relative': 5,
                        'absolute': 100
                    },
                    'down': {
                        'relative': 5,
                        'absolute': 100
                    }
                },
                'scaling': {
                    'up': {
                        'relative': 'none',
                        'absolute': 'standard'
                    },
                    'down': {
                        'relative': 'none',
                        'absolute': 'standard'
                    }
                }
            },
            'submetrics': ['TWITTER_TWEETS_RETWEETS', 'TWITTER_TWEETS_FAVORITES', 'TWITTER_TWEETS_REPLIES'],
            'rollupSource': 'twitterTrends',
            'propSummary': 'tweets_engagement_total',
            'propDaily': 'daily_tweets_engagement_total'
        },
        'TWITTER_AVERAGE_DAILY_TWEETS_ENGAGEMENT_TOTAL': {
            'id': 10105,
            'source': source.TWITTER,
            'dataType': dataType.NUMERIC,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Average Engagement Total per Day',
            'abbreviatedName': 'Avg. Engagement Total per Day',
            'exportName': 'Average Daily Total Engagement for Tweets',
            'abbreviatedExportName': 'Avg. Daily Total Engagement',
            description: strings.twitter_average_daily_tweets_engagement_total_description,
            'iconUrl': iconUrls[source.TWITTER],
            'submetrics': ['TWITTER_AVERAGE_DAILY_TWEETS_RETWEETS', 'TWITTER_AVERAGE_DAILY_TWEETS_FAVORITES', 'TWITTER_AVERAGE_DAILY_TWEETS_REPLIES'],
            'rollupSource': 'twitterTrends',
            'propSummary': 'average_daily_tweets_engagement_total',
            'propDaily': 'daily_tweets_engagement_total'
        },
        'TWITTER_TWEETS_ENGAGEMENT_RATE': {
            'id': 10006,
            'source': source.TWITTER,
            'dataType': dataType.ABSOLUTE_PERCENT,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Tweet Engagement Rate',
            'abbreviatedName': 'Tweet Engagement Rate',
            'exportName': 'Engagement Rate for Tweets',
            description: strings.twitter_tweets_engagement_rate_description,
            'iconUrl': iconUrls[source.TWITTER],
            'rollupSource': 'twitterTrends',
            'propSummary': 'tweets_engagement_rate',
            'propDaily': 'daily_tweets_engagement_rate'
        },
        'TWITTER_AVERAGE_DAILY_TWEETS_ENGAGEMENT_RATE': {
            'id': 10106,
            'source': source.TWITTER,
            'dataType': dataType.ABSOLUTE_PERCENT,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Average Engagement Rate per Day',
            'abbreviatedName': 'Avg. Engagement Rate per Day',
            'exportName': 'Average Daily Engagement Rate for Tweets',
            description: strings.twitter_average_daily_tweets_engagement_rate_description,
            'iconUrl': iconUrls[source.TWITTER],
            'rollupSource': 'twitterTrends',
            'propSummary': 'average_daily_tweets_engagement_rate',
            'propDaily': 'daily_tweets_engagement_rate'
        },
        'TWITTER_AVERAGE_TWEET_ENGAGEMENT_TOTAL': {
            'id': 10007,
            'source': source.TWITTER,
            'dataType': dataType.NUMERIC,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Average Engagement Total per Tweet',
            'abbreviatedName': 'Avg. Engagement Total per Tweet',
            'exportName': 'Average Total Engagement per Tweet',
            description: strings.twitter_average_tweet_engagement_total_description,
            'iconUrl': iconUrls[source.TWITTER],
            'rollupSource': 'twitterTrends',
            'propSummary': 'average_tweet_engagement_total',
            'propDaily': 'daily_average_tweet_engagement_total'
        },
        'TWITTER_AVERAGE_TWEET_ENGAGEMENT_RATE': {
            'id': 10008,
            'source': source.TWITTER,
            'dataType': dataType.ABSOLUTE_PERCENT,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'apiName': 'Twitter Average Engagement Rate per Tweet',
            'name': 'Engagement Rate by Follower',
            'abbreviatedName': 'Engagement Rate by Follower',
            'exportName': 'Engagement Rate by Follower',
            description: strings.twitter_average_tweet_engagement_rate_description,
            'iconUrl': iconUrls[source.TWITTER],
            'rollupSource': 'twitterTrends',
            'propSummary': 'average_tweet_engagement_rate',
            'propDaily': 'daily_average_tweet_engagement_rate'
        },
        'TWITTER_OVERVIEW': {
            'id': 10009,
            'source': source.TWITTER,
            'dataType': dataType.STRING,
            'category': category.POSITIONING,
            'metricType': metricType.TEXT,
            'name': 'Twitter Bio',
            'abbreviatedName': 'Bio',
            description: strings.twitter_overview_description,
            'iconUrl': iconUrls[source.TWITTER],
            'columns': ['length'],
            'rollupSource': 'twitterTrends',
            'propSummary': 'overview',
            'propDaily': 'overview'
        },
        'TWITTER_LIFETIME_TWEETS': {
            'id': 10011,
            'source': source.TWITTER,
            'dataType': dataType.INTEGER,
            'category': category.ACTIVITY,
            'metricType': metricType.TOTAL,
            'name': 'Twitter Lifetime Tweets',
            'abbreviatedName': 'Lifetime Tweets',
            description: strings.twitter_lifetime_tweets_description,
            'iconUrl': iconUrls[source.TWITTER],
            'rollupSource': 'twitterTrends',
            'propSummary': 'lifetime_tweets',
            'propDaily': 'lifetime_tweets'
        },
        'TWITTER_NORMAL_TWEETS': {
            'id': 10013,
            'source': source.TWITTER,
            'dataType': dataType.INTEGER,
            'category': category.ACTIVITY,
            'metricType': metricType.VOLUME,
            'name': 'Tweets',
            'shortName': 'Tweets',
            'exportName': 'Tweet',
            description: strings.twitter_normal_tweets_description,
            'iconUrl': iconUrls[source.TWITTER],
            'rollupSource': 'twitterTrends',
            'propSummary': 'normal_tweets',
            'propDaily': 'daily_normal_tweets'
        },
        'TWITTER_AVERAGE_DAILY_NORMAL_TWEETS': {
            'id': 10113,
            'source': source.TWITTER,
            'dataType': dataType.NUMERIC,
            'category': category.ACTIVITY,
            'metricType': metricType.VOLUME,
            'name': 'Average Tweets per Day',
            'shortName': 'Tweets',
            'exportName': 'Average Daily Tweet',
            description: strings.twitter_average_daily_normal_tweets_description,
            'iconUrl': iconUrls[source.TWITTER],
            'rollupSource': 'twitterTrends',
            'propSummary': 'average_daily_normal_tweets',
            'propDaily': 'daily_normal_tweets'
        },
        'TWITTER_RETWEET_TWEETS': {
            'id': 10014,
            'source': source.TWITTER,
            'dataType': dataType.INTEGER,
            'category': category.ACTIVITY,
            'metricType': metricType.VOLUME,
            'name': 'Retweet Tweets',
            'shortName': 'Retweet Tweets',
            'exportName': 'Retweet Tweet',
            description: strings.twitter_retweet_tweets_description,
            'iconUrl': iconUrls[source.TWITTER],
            'rollupSource': 'twitterTrends',
            'propSummary': 'retweet_tweets',
            'propDaily': 'daily_retweet_tweets'
        },
        'TWITTER_AVERAGE_DAILY_RETWEET_TWEETS': {
            'id': 10114,
            'source': source.TWITTER,
            'dataType': dataType.NUMERIC,
            'category': category.ACTIVITY,
            'metricType': metricType.VOLUME,
            'name': 'Average Retweet Tweets per Day',
            'shortName': 'Retweet Tweets',
            'exportName': 'Average Daily Retweet Tweet',
            description: strings.twitter_average_daily_retweet_tweets_description,
            'iconUrl': iconUrls[source.TWITTER],
            'rollupSource': 'twitterTrends',
            'propSummary': 'average_daily_retweet_tweets',
            'propDaily': 'daily_retweet_tweets'
        },
        'TWITTER_REPLY_TWEETS': {
            'id': 10015,
            'source': source.TWITTER,
            'dataType': dataType.INTEGER,
            'category': category.ACTIVITY,
            'metricType': metricType.VOLUME,
            'name': 'Reply Tweets',
            'shortName': 'Reply Tweets',
            'exportName': 'Reply Tweets',
            description: strings.twitter_reply_tweets_description,
            'iconUrl': iconUrls[source.TWITTER],
            'rollupSource': 'twitterTrends',
            'propSummary': 'reply_tweets',
            'propDaily': 'daily_reply_tweets'
        },
        'TWITTER_AVERAGE_DAILY_REPLY_TWEETS': {
            'id': 10115,
            'source': source.TWITTER,
            'dataType': dataType.NUMERIC,
            'category': category.ACTIVITY,
            'metricType': metricType.VOLUME,
            'name': 'Average Reply Tweets per Day',
            'shortName': 'Replies',
            'exportName': 'Average Daily Reply Tweet',
            description: strings.twitter_average_daily_reply_tweets_description,
            'iconUrl': iconUrls[source.TWITTER],
            'rollupSource': 'twitterTrends',
            'propSummary': 'average_daily_reply_tweets',
            'propDaily': 'daily_reply_tweets'
        },
        'TWITTER_FOLLOWERS_FOLLOWING_RATIO': {
            'id': 10016,
            'source': source.TWITTER,
            'dataType': dataType.NUMERIC,
            'category': category.REACH,
            'metricType': metricType.VOLUME,
            'name': 'Twitter Follower to Following Ratio',
            'abbreviatedName': 'Follower/Following Ratio',
            description: strings.twitter_followers_following_ratio_description,
            'iconUrl': iconUrls[source.TWITTER],
            'rollupSource': 'twitterTrends',
            'propSummary': 'followers_to_following',
            'propDaily': 'followers_to_following'
        },
        'TWITTER_TWEETS_REPLIES': {
            'id': 10017,
            'source': source.TWITTER,
            'dataType': dataType.INTEGER,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Replies to Company Tweets',
            'abbreviatedName': 'Reply Tweets',
            'shortName': 'Replies',
            'exportName': 'Replies to Company Tweet',
            description: strings.twitter_tweets_replies_description,
            'iconUrl': iconUrls[source.TWITTER],
            'rollupSource': 'twitterTrends',
            'propSummary': 'replies',
            'propDaily': 'daily_replies'
        },
        'TWITTER_AVERAGE_DAILY_TWEETS_REPLIES': {
            'id': 10117,
            'source': source.TWITTER,
            'dataType': dataType.NUMERIC,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Average Replies per Day',
            'exportName': 'Average Daily Reply',
            description: strings.twitter_average_daily_tweets_replies_description,
            'iconUrl': iconUrls[source.TWITTER],
            'rollupSource': 'twitterTrends',
            'propSummary': 'average_daily_replies',
            'propDaily': 'daily_replies'
        },
        'TWITTER_TWEETS_VIDEO_VIEWS': {
            'id': 10018,
            'source': source.TWITTER,
            'dataType': dataType.INTEGER,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Video Views',
            'abbreviatedName': 'Video Views',
            'shortName': 'Video Views',
            'exportName': 'Video Views',
            description: strings.twitter_tweets_video_views_description,
            'iconUrl': iconUrls[source.TWITTER],
            'rollupSource': 'twitterTrends',
            'propSummary': 'video_views',
            'propDaily': 'daily_video_views'
        },
        'TWITTER_AVERAGE_DAILY_TWEETS_VIDEO_VIEWS': {
            'id': 10118,
            'source': source.TWITTER,
            'dataType': dataType.NUMERIC,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Average Video Views per Day',
            'exportName': 'Average Daily Video View',
            description: strings.twitter_average_daily_tweets_video_views_description,
            'iconUrl': iconUrls[source.TWITTER],
            'rollupSource': 'twitterTrends',
            'propSummary': 'average_daily_video_views',
            'propDaily': 'daily_video_views'
        },
        'TWITTER_ESTIMATED_IMPRESSIONS': {
            'id': 10119,
            'source': source.TWITTER,
            'dataType': dataType.NUMERIC,
            'category': category.REACH,
            'metricType': metricType.VOLUME,
            'name': 'Twitter Estimated Impressions',
            'abbreviatedName': 'Estimated Impressions',
            description: strings.estimated_impressions_description,
            'iconUrl': iconUrls[source.TWITTER],
            'rollupSource': 'twitterTrends',
            'propSummary': 'estimated_impressions',
            'propDaily': 'daily_estimated_impressions'
        },
        'TWITTER_ENGAGEMENT_RATE_BY_ESTIMATED_IMPRESSION': {
            'id': 10120,
            'source': source.TWITTER,
            'dataType': dataType.ABSOLUTE_PERCENT,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Twitter Engagement Rate by Estimated Impression',
            'abbreviatedName': 'Eng. Rate by Est. Impressions',
            description: strings.engagement_rate_by_estimated_impression_description,
            'iconUrl': iconUrls[source.TWITTER],
            'rollupSource': 'twitterTrends',
            'propSummary': 'engagement_rate_by_estimated_impression',
            'propDaily': 'daily_engagement_rate_by_estimated_impression'
        },
        'TWITTER_IMPRESSIONS': {
            'id': 10121,
            'source': source.TWITTER,
            'dataType': dataType.NUMERIC,
            'category': category.REACH,
            'metricType': metricType.VOLUME,
            'name': 'Twitter Impressions',
            'abbreviatedName': 'Impressions',
            description: strings.twitter_impressions_description,
            'iconUrl': iconUrls[source.TWITTER],
            'rollupSource': 'twitterTrends',
            'propSummary': 'impressions',
            'propDaily': 'daily_impressions'
        },
        'YOUTUBE_SUBSCRIBERS': {
            'id': 17000,
            'source': source.YOUTUBE,
            'dataType': dataType.INTEGER,
            'category': category.REACH,
            'metricType': metricType.TOTAL,
            'name': 'YouTube Subscribers',
            'abbreviatedName': 'Subscribers',
            description: strings.youtube_subscribers_description,
            'iconUrl': iconUrls[source.YOUTUBE],
            'activityFilter': {
                'include': true,
                'event': {
                    'up': {
                        'relative': 0.1,
                        'absolute': 100
                    },
                    'down': {
                        'relative': 0.1,
                        'absolute': 100
                    },
                    'ignoreZeros': true
                },
                'default': {
                    'up': {
                        'relative': 0.1,
                        'absolute': 100
                    },
                    'down': {
                        'relative': 0.1,
                        'absolute': 100
                    },
                    'ignoreZeros': true
                },
                'scaling': {
                    'up': {
                        'relative': 'standard',
                        'absolute': 'standard'
                    },
                    'down': {
                        'relative': 'standard',
                        'absolute': 'standard'
                    }
                }
            },
            'rollupSource': 'youTubeTrends',
            'propSummary': 'audience',
            'propDaily': 'audience'
        },
        'YOUTUBE_PRESENCE_REACH': {
            'id': 17100,
            'source': source.YOUTUBE,
            'dataType': dataType.INTEGER,
            'category': category.REACH,
            'metricType': metricType.TOTAL,
            'name': 'YouTube Subscribers',
            'abbreviatedName': 'Subscribers',
            description: strings.youtube_presence_reach_description,
            'iconUrl': iconUrls[source.YOUTUBE],
            'dontShowInUi': true,
            'rollupSource': 'youTubeTrends',
            'propSummary': 'presence_reach',
            'propDaily': 'presence_reach'
        },
        'YOUTUBE_VIDEOS': {
            'id': 17001,
            'source': source.YOUTUBE,
            'dataType': dataType.INTEGER,
            'category': category.ACTIVITY,
            'metricType': metricType.TOTAL,
            'name': 'YouTube Videos',
            'abbreviatedName': 'Videos',
            description: strings.youtube_videos_description,
            'iconUrl': iconUrls[source.YOUTUBE],
            'rollupSource': 'youTubeTrends',
            'propSummary': 'videos',
            'propDaily': 'videos'
        },
        'YOUTUBE_VIEWS': {
            'id': 17002,
            'source': source.YOUTUBE,
            'dataType': dataType.INTEGER,
            'category': category.ENGAGEMENT,
            'metricType': metricType.TOTAL,
            'name': 'YouTube Lifetime Views',
            'abbreviatedName': 'Lifetime Views',
            'shortName': 'Views',
            description: `${strings.youtube_views_description} ${strings.youtube_public_view_count_change_description}`,
            'iconUrl': iconUrls[source.YOUTUBE],
            'rollupSource': 'youTubeTrends',
            'propSummary': 'views',
            'propDaily': 'views'
        },
        // DEPRECATED, but left here so that the public API still generates data for it.
        'YOUTUBE_COMMENTS': {
            'id': 17003,
            'source': source.YOUTUBE,
            'dataType': dataType.INTEGER,
            'category': category.ENGAGEMENT,
            'metricType': metricType.TOTAL,
            'name': 'YouTube Comments',
            'abbreviatedName': 'Comments',
            'shortName': 'Comments',
            'apiOnly': true,
            'iconUrl': iconUrls[source.YOUTUBE],
            'rollupSource': 'youTubeTrends',
            'propSummary': 'comments',
            'propDaily': 'comments'
        },
        'YOUTUBE_POSTS': {
            'id': 17004,
            'source': source.YOUTUBE,
            'dataType': dataType.INTEGER,
            'category': category.ACTIVITY,
            'metricType': metricType.VOLUME,
            'name': 'YouTube Posts',
            'abbreviatedName': 'Posts',
            'exportName': 'YouTube Post',
            'abbreviatedExportName': 'Post',
            description: strings.youtube_posts_description,
            'iconUrl': iconUrls[source.YOUTUBE],
            'rollupSource': 'youTubeTrends',
            'propSummary': 'posts',
            'propDaily': 'daily_posts'
        },
        'YOUTUBE_AVERAGE_DAILY_POSTS': {
            'id': 17104,
            'source': source.YOUTUBE,
            'dataType': dataType.NUMERIC,
            'category': category.ACTIVITY,
            'metricType': metricType.VOLUME,
            'name': 'Average YouTube Posts per Day',
            'abbreviatedName': 'Avg. Posts per Day',
            'exportName': 'Average Daily YouTube Post',
            'abbreviatedExportName': 'Avg. Post',
            description: strings.youtube_average_daily_posts_description,
            'iconUrl': iconUrls[source.YOUTUBE],
            'rollupSource': 'youTubeTrends',
            'propSummary': 'average_daily_posts',
            'propDaily': 'daily_posts'
        },
        'YOUTUBE_POSTS_VIEWS': {
            'id': 17005,
            'source': source.YOUTUBE,
            'dataType': dataType.INTEGER,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'YouTube Post Views',
            'abbreviatedName': 'Post Views',
            'shortName': 'Views',
            'exportName': 'YouTube Post View',
            'abbreviatedExportName': 'Post View',
            description: `${strings.youtube_posts_views_description} ${strings.youtube_public_view_count_change_description}`,
            'iconUrl': iconUrls[source.YOUTUBE],
            'rollupSource': 'youTubeTrends',
            'propSummary': 'posts_views',
            'propDaily': 'daily_posts_views'
        },
        'YOUTUBE_AVERAGE_DAILY_POSTS_VIEWS': {
            'id': 17105,
            'source': source.YOUTUBE,
            'dataType': dataType.NUMERIC,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Average YouTube Post Views per Day',
            'abbreviatedName': 'Avg. Post Views per Day',
            'exportName': 'Average Daily YouTube Post View',
            'abbreviatedExportName': 'Avg. Post View',
            description: `${strings.youtube_average_daily_posts_views_description} ${strings.youtube_public_view_count_change_description}`,
            'iconUrl': iconUrls[source.YOUTUBE],
            'rollupSource': 'youTubeTrends',
            'propSummary': 'average_daily_posts_views',
            'propDaily': 'daily_posts_views'
        },
        'YOUTUBE_POSTS_LIKES': {
            'id': 17006,
            'source': source.YOUTUBE,
            'dataType': dataType.INTEGER,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'YouTube Post Likes',
            'abbreviatedName': 'Post Likes',
            'shortName': 'Likes',
            'exportName': 'YouTube Post Like',
            'abbreviatedExportName': 'Post Like',
            description: strings.youtube_posts_likes_description,
            'iconUrl': iconUrls[source.YOUTUBE],
            'rollupSource': 'youTubeTrends',
            'propSummary': 'posts_likes',
            'propDaily': 'daily_posts_likes'
        },
        'YOUTUBE_AVERAGE_DAILY_POSTS_LIKES': {
            'id': 17106,
            'source': source.YOUTUBE,
            'dataType': dataType.NUMERIC,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Average YouTube Post Likes per Day',
            'abbreviatedName': 'Avg. Post Likes per Day',
            'exportName': 'Average Daily YouTube Post Like',
            'abbreviatedExportName': 'Avg. Post Like',
            description: strings.youtube_average_daily_posts_likes_description,
            'iconUrl': iconUrls[source.YOUTUBE],
            'rollupSource': 'youTubeTrends',
            'propSummary': 'average_daily_posts_likes',
            'propDaily': 'daily_posts_likes'
        },
        // NOTE 17007 deprecated
        // NOTE 17107 deprecated
        'YOUTUBE_POSTS_COMMENTS': {
            'id': 17008,
            'source': source.YOUTUBE,
            'dataType': dataType.INTEGER,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'YouTube Post Comments',
            'abbreviatedName': 'Post Comments',
            'shortName': 'Comments',
            'exportName': 'YouTube Post Comment',
            'abbreviatedExportName': 'Post Comment',
            description: strings.youtube_posts_comments_description,
            'iconUrl': iconUrls[source.YOUTUBE],
            'rollupSource': 'youTubeTrends',
            'propSummary': 'posts_comments',
            'propDaily': 'daily_posts_comments'
        },
        'YOUTUBE_AVERAGE_DAILY_POSTS_COMMENTS': {
            'id': 17108,
            'source': source.YOUTUBE,
            'dataType': dataType.NUMERIC,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Average YouTube Post Comments per Day',
            'abbreviatedName': 'Avg. Post Comments per Day',
            'exportName': 'Average Daily YouTube Post Comment',
            'abbreviatedExportName': 'Avg. Post Comment',
            description: strings.youtube_average_daily_posts_comments_description,
            'iconUrl': iconUrls[source.YOUTUBE],
            'rollupSource': 'youTubeTrends',
            'propSummary': 'average_daily_posts_comments',
            'propDaily': 'daily_posts_comments'
        },
        'YOUTUBE_POSTS_ENGAGEMENT_TOTAL': {
            'id': 17009,
            'source': source.YOUTUBE,
            'dataType': dataType.INTEGER,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'YouTube Posts Engagement Total',
            'abbreviatedName': 'Post Engagement Total',
            'exportName': 'Engagement Total for YouTube Posts',
            'abbreviatedExportName': 'Engagement Total for Posts',
            description: strings.youtube_posts_engagement_total_description,
            'iconUrl': iconUrls[source.YOUTUBE],
            'activityFilter': {
                'include': true,
                'event': {
                    'up': {
                        'relative': 5,
                        'absolute': 100
                    }
                },
                'default': {
                    'up': {
                        'relative': 5,
                        'absolute': 100
                    },
                    'down': {
                        'relative': 5,
                        'absolute': 100
                    }
                },
                'scaling': {
                    'up': {
                        'relative': 'none',
                        'absolute': 'standard'
                    },
                    'down': {
                        'relative': 'none',
                        'absolute': 'standard'
                    }
                }
            },
            'submetrics': ['YOUTUBE_POSTS_LIKES', 'YOUTUBE_POSTS_COMMENTS'],
            'rollupSource': 'youTubeTrends',
            'propSummary': 'posts_engagement_total',
            'propDaily': 'daily_posts_engagement_total'
        },
        'YOUTUBE_AVERAGE_DAILY_POSTS_ENGAGEMENT_TOTAL': {
            'id': 17109,
            'source': source.YOUTUBE,
            'dataType': dataType.NUMERIC,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Average YouTube Posts Engagement Total per Day',
            'abbreviatedName': 'Avg. Post Engagement Total per Day',
            'exportName': 'Average Daily Engagement Total for YouTube Posts',
            'abbreviatedExportName': 'Avg. Engagement Total for Posts',
            description: strings.youtube_average_daily_posts_engagement_total_description,
            'iconUrl': iconUrls[source.YOUTUBE],
            'submetrics': ['YOUTUBE_AVERAGE_DAILY_POSTS_LIKES', 'YOUTUBE_AVERAGE_DAILY_POSTS_COMMENTS'],
            'rollupSource': 'youTubeTrends',
            'propSummary': 'average_daily_posts_engagement_total',
            'propDaily': 'daily_posts_engagement_total'
        },
        'YOUTUBE_POSTS_ENGAGEMENT_RATE': {
            'id': 17010,
            'source': source.YOUTUBE,
            'dataType': dataType.ABSOLUTE_PERCENT,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'YouTube Posts Engagement Rate',
            'abbreviatedName': 'Post Engagement Rate',
            'exportName': 'Engagement Rate for YouTube Posts',
            'abbreviatedExportName': 'Engagement Rate for Posts',
            description: strings.youtube_posts_engagement_rate_description,
            'iconUrl': iconUrls[source.YOUTUBE],
            'rollupSource': 'youTubeTrends',
            'propSummary': 'posts_engagement_rate',
            'propDaily': 'daily_posts_engagement_rate'
        },
        'YOUTUBE_AVERAGE_DAILY_POSTS_ENGAGEMENT_RATE': {
            'id': 17110,
            'source': source.YOUTUBE,
            'dataType': dataType.ABSOLUTE_PERCENT,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Average YouTube Posts Engagement Rate per Day',
            'abbreviatedName': 'Avg. Post Engagement Rate per Day',
            'exportName': 'Average Daily Engagement Rate for YouTube Posts',
            'abbreviatedExportName': 'Avg. Engagement Rate for Posts',
            description: strings.youtube_average_daily_posts_engagement_rate_description,
            'iconUrl': iconUrls[source.YOUTUBE],
            'rollupSource': 'youTubeTrends',
            'propSummary': 'average_daily_posts_engagement_rate',
            'propDaily': 'daily_posts_engagement_rate'
        },
        'YOUTUBE_AVERAGE_POST_ENGAGEMENT_TOTAL': {
            'id': 17011,
            'source': source.YOUTUBE,
            'dataType': dataType.NUMERIC,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'YouTube Average Engagement Total per Post',
            'abbreviatedName': 'Avg. Engagement Total per Post',
            'exportName': 'Average Engagement Total per YouTube Post',
            'abbreviatedExportName': 'Avg. Engagement Total per Post',
            description: strings.youtube_average_post_engagement_total_description,
            'iconUrl': iconUrls[source.YOUTUBE],
            'rollupSource': 'youTubeTrends',
            'propSummary': 'average_post_engagement_total',
            'propDaily': 'daily_average_post_engagement_total'
        },
        'YOUTUBE_AVERAGE_POST_ENGAGEMENT_RATE': {
            'id': 17012,
            'source': source.YOUTUBE,
            'dataType': dataType.ABSOLUTE_PERCENT,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'apiName': 'YouTube Average Engagement Rate per Post',
            'name': 'YouTube Engagement Rate by Follower',
            'abbreviatedName': 'Engagement Rate by Follower',
            'exportName': 'YouTube Engagement Rate by Follower',
            'abbreviatedExportName': 'Engagement Rate by Follower',
            description: strings.youtube_average_post_engagement_rate_description,
            'iconUrl': iconUrls[source.YOUTUBE],
            'rollupSource': 'youTubeTrends',
            'propSummary': 'average_post_engagement_rate',
            'propDaily': 'daily_average_post_engagement_rate'
        },
        'YOUTUBE_OVERVIEW': {
            'id': 17013,
            'source': source.YOUTUBE,
            'dataType': dataType.STRING,
            'category': category.POSITIONING,
            'metricType': metricType.TEXT,
            'name': 'YouTube Description',
            'abbreviatedName': 'Description',
            description: strings.youtube_overview_description,
            'iconUrl': iconUrls[source.YOUTUBE],
            'columns': ['length'],
            'rollupSource': 'youTubeTrends',
            'propSummary': 'overview',
            'propDaily': 'overview'
        },
        'YOUTUBE_TITLE': {
            'id': 17014,
            'source': source.YOUTUBE,
            'dataType': dataType.STRING,
            'category': category.POSITIONING,
            'metricType': metricType.TEXT,
            'name': 'YouTube Title',
            'abbreviatedName': 'Title',
            description: strings.youtube_title_description,
            'iconUrl': iconUrls[source.YOUTUBE],
            'columns': ['length'],
            'rollupSource': 'youTubeTrends',
            'propSummary': 'title',
            'propDaily': 'title'
        },
        'YOUTUBE_KEYWORDS': {
            'id': 17015,
            'source': source.YOUTUBE,
            'dataType': dataType.STRING,
            'category': category.POSITIONING,
            'metricType': metricType.TEXT,
            'name': 'YouTube Keywords',
            'abbreviatedName': 'Keywords',
            description: strings.youtube_keywords_description,
            'iconUrl': iconUrls[source.YOUTUBE],
            'rollupSource': 'youTubeTrends',
            'propSummary': 'keywords',
            'propDaily': 'keywords'
        },
        'YOUTUBE_ENGAGEMENT_TOTAL_PER_VIEW': {
            'id': 17016,
            'source': source.YOUTUBE,
            'dataType': dataType.NUMERIC,
            'metricType': metricType.VOLUME,
            'name': 'engagement_rate_by_view',
            'exportName': 'YOUTUBE engagement_rate_by_view',
            description: `${strings.youtube_engagement_total_per_view_description} ${strings.youtube_public_view_count_change_description} ${strings.youtube_view_count_denominator_change_description}`,
            'rollupSource': 'youTubeTrends',
            'propSummary': 'engagement_total_per_view',
            'propDaily': 'daily_engagement_total_per_view'
        },
        'YOUTUBE_ESTIMATED_IMPRESSIONS': {
            'id': 17017,
            'source': source.YOUTUBE,
            'dataType': dataType.NUMERIC,
            'category': category.REACH,
            'metricType': metricType.VOLUME,
            'name': 'YouTube Estimated Impressions',
            'abbreviatedName': 'Estimated Impressions',
            description: `${strings.estimated_impressions_description} ${strings.youtube_public_view_count_change_description}`,
            'iconUrl': iconUrls[source.YOUTUBE],
            'rollupSource': 'youTubeTrends',
            'propSummary': 'estimated_impressions',
            'propDaily': 'daily_estimated_impressions'
        },
        'YOUTUBE_ENGAGEMENT_RATE_BY_ESTIMATED_IMPRESSION': {
            'id': 17018,
            'source': source.YOUTUBE,
            'dataType': dataType.ABSOLUTE_PERCENT,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'YouTube Engagement Rate by Estimated Impression',
            'abbreviatedName': 'Eng. Rate by Est. Impressions',
            description: `${strings.engagement_rate_by_estimated_impression_description} ${strings.youtube_public_view_count_change_description} ${strings.youtube_view_count_denominator_change_description}`,
            'iconUrl': iconUrls[source.YOUTUBE],
            'rollupSource': 'youTubeTrends',
            'propSummary': 'engagement_rate_by_estimated_impression',
            'propDaily': 'daily_engagement_rate_by_estimated_impression'
        },
        'INSTAGRAM_FOLLOWED_BY': {
            'id': 18000,
            'source': source.INSTAGRAM,
            'dataType': dataType.INTEGER,
            'category': category.REACH,
            'metricType': metricType.TOTAL,
            'name': 'Instagram Followed By',
            'abbreviatedName': 'Followed By',
            description: strings.instagram_followed_by_description,
            'iconUrl': iconUrls[source.INSTAGRAM],
            'activityFilter': {
                'include': true,
                'event': {
                    'up': {
                        'relative': 0.1,
                        'absolute': 100
                    },
                    'down': {
                        'relative': 0.1,
                        'absolute': 100
                    },
                    'ignoreZeros': true
                },
                'default': {
                    'up': {
                        'relative': 0.1,
                        'absolute': 100
                    },
                    'down': {
                        'relative': 0.1,
                        'absolute': 100
                    },
                    'ignoreZeros': true
                },
                'scaling': {
                    'up': {
                        'relative': 'standard',
                        'absolute': 'standard'
                    },
                    'down': {
                        'relative': 'standard',
                        'absolute': 'standard'
                    }
                }
            },
            'rollupSource': 'instagramTrends',
            'propSummary': 'audience',
            'propDaily': 'audience'
        },
        'INSTAGRAM_PRESENCE_REACH': {
            'id': 18100,
            'source': source.INSTAGRAM,
            'dataType': dataType.INTEGER,
            'category': category.REACH,
            'metricType': metricType.TOTAL,
            'name': 'Instagram Followed By',
            'abbreviatedName': 'Followed By',
            description: strings.instagram_presence_reach_description,
            'iconUrl': iconUrls[source.INSTAGRAM],
            'dontShowInUi': true,
            'rollupSource': 'instagramTrends',
            'propSummary': 'presence_reach',
            'propDaily': 'presence_reach'
        },
        'INSTAGRAM_FOLLOWS': {
            'id': 18001,
            'source': source.INSTAGRAM,
            'dataType': dataType.INTEGER,
            'category': category.REACH,
            'metricType': metricType.TOTAL,
            'name': 'Instagram Follows',
            'abbreviatedName': 'Follows',
            description: strings.instagram_following_description,
            'iconUrl': iconUrls[source.INSTAGRAM],
            'rollupSource': 'instagramTrends',
            'propSummary': 'follows',
            'propDaily': 'follows'
        },
        'INSTAGRAM_LIFETIME_POSTS': {
            'id': 18002,
            'source': source.INSTAGRAM,
            'dataType': dataType.INTEGER,
            'category': category.ACTIVITY,
            'metricType': metricType.VOLUME,
            'name': 'Instagram Lifetime Posts',
            'abbreviatedName': 'Lifetime Posts',
            'exportName': 'Instagram Lifetime Posts',
            'abbreviatedExportName': 'Lifetime Posts',
            description: strings.instagram_lifetime_posts_description,
            'iconUrl': iconUrls[source.INSTAGRAM],
            'rollupSource': 'instagramTrends',
            'propSummary': 'media',
            'propDaily': 'media'
        },
        'INSTAGRAM_POSTS': {
            'id': 18003,
            'source': source.INSTAGRAM,
            'dataType': dataType.INTEGER,
            'category': category.ACTIVITY,
            'metricType': metricType.VOLUME,
            'name': 'Instagram Posts',
            'abbreviatedName': 'Posts',
            'exportName': 'Instagram Post',
            'abbreviatedExportName': 'Post',
            description: strings.instagram_posts_description,
            'iconUrl': iconUrls[source.INSTAGRAM],
            'rollupSource': 'instagramTrends',
            'propSummary': 'posts',
            'propDaily': 'daily_posts'
        },
        'INSTAGRAM_AVERAGE_DAILY_POSTS': {
            'id': 18103,
            'source': source.INSTAGRAM,
            'dataType': dataType.NUMERIC,
            'category': category.ACTIVITY,
            'metricType': metricType.VOLUME,
            'name': 'Average Instagram Posts per Day',
            'abbreviatedName': 'Avg. Posts per Day',
            'exportName': 'Average Daily Instagram Post',
            'abbreviatedExportName': 'Avg. Post',
            description: strings.instagram_average_daily_posts_description,
            'iconUrl': iconUrls[source.INSTAGRAM],
            'rollupSource': 'instagramTrends',
            'propSummary': 'average_daily_posts',
            'propDaily': 'daily_posts'
        },
        'INSTAGRAM_POSTS_LIKES': {
            'id': 18004,
            'source': source.INSTAGRAM,
            'dataType': dataType.INTEGER,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Instagram Post Likes',
            'abbreviatedName': 'Post Likes',
            'shortName': 'Likes',
            'exportName': 'Instagram Post Like',
            'abbreviatedExportName': 'Post Like',
            description: strings.instagram_posts_likes_description,
            'iconUrl': iconUrls[source.INSTAGRAM],
            'rollupSource': 'instagramTrends',
            'propSummary': 'posts_likes',
            'propDaily': 'daily_posts_likes'
        },
        'INSTAGRAM_AVERAGE_DAILY_POSTS_LIKES': {
            'id': 18104,
            'source': source.INSTAGRAM,
            'dataType': dataType.NUMERIC,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Average Instagram Post Likes per Day',
            'abbreviatedName': 'Avg. Post Likes per Day',
            'exportName': 'Average Daily Instagram Post Like',
            'abbreviatedExportName': 'Avg. Post Like',
            description: strings.instagram_average_daily_posts_likes_description,
            'iconUrl': iconUrls[source.INSTAGRAM],
            'rollupSource': 'instagramTrends',
            'propSummary': 'average_daily_posts_likes',
            'propDaily': 'daily_posts_likes'
        },
        'INSTAGRAM_POSTS_COMMENTS': {
            'id': 18005,
            'source': source.INSTAGRAM,
            'dataType': dataType.INTEGER,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Instagram Post Comments',
            'abbreviatedName': 'Post Comments',
            'shortName': 'Comments',
            'exportName': 'Instagram Post Comment',
            'abbreviatedExportName': 'Post Comment',
            description: strings.instagram_posts_comments_description,
            'iconUrl': iconUrls[source.INSTAGRAM],
            'rollupSource': 'instagramTrends',
            'propSummary': 'posts_comments',
            'propDaily': 'daily_posts_comments'
        },
        'INSTAGRAM_AVERAGE_DAILY_POSTS_COMMENTS': {
            'id': 18105,
            'source': source.INSTAGRAM,
            'dataType': dataType.NUMERIC,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Average Instagram Post Comments per Day',
            'abbreviatedName': 'Avg. Post Comments per Day',
            'exportName': 'Average Daily Instagram Post Comment',
            'abbreviatedExportName': 'Avg. Post Comment',
            description: strings.instagram_average_daily_posts_comments_description,
            'iconUrl': iconUrls[source.INSTAGRAM],
            'rollupSource': 'instagramTrends',
            'propSummary': 'average_daily_posts_comments',
            'propDaily': 'daily_posts_comments'
        },
        'INSTAGRAM_POSTS_ENGAGEMENT_TOTAL': {
            'id': 18006,
            'source': source.INSTAGRAM,
            'dataType': dataType.INTEGER,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Instagram Posts Engagement Total',
            'abbreviatedName': 'Post Engagement Total',
            'exportName': 'Engagement Total for Instagram Posts',
            'abbreviatedExportName': 'Engagement Total for Posts',
            description: strings.instagram_posts_engagement_total_description,
            'iconUrl': iconUrls[source.INSTAGRAM],
            'activityFilter': {
                'include': true,
                'event': {
                    'up': {
                        'relative': 5,
                        'absolute': 100
                    }
                },
                'default': {
                    'up': {
                        'relative': 5,
                        'absolute': 100
                    },
                    'down': {
                        'relative': 5,
                        'absolute': 100
                    }
                },
                'scaling': {
                    'up': {
                        'relative': 'none',
                        'absolute': 'standard'
                    },
                    'down': {
                        'relative': 'none',
                        'absolute': 'standard'
                    }
                }
            },
            'submetrics': ['INSTAGRAM_POSTS_LIKES', 'INSTAGRAM_POSTS_COMMENTS'],
            'rollupSource': 'instagramTrends',
            'propSummary': 'posts_engagement_total',
            'propDaily': 'daily_posts_engagement_total'
        },
        'INSTAGRAM_AVERAGE_DAILY_POSTS_ENGAGEMENT_TOTAL': {
            'id': 18106,
            'source': source.INSTAGRAM,
            'dataType': dataType.NUMERIC,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Average Instagram Posts Engagement Total per Day',
            'abbreviatedName': 'Avg. Post Engagement Total per Day',
            'exportName': 'Average Daily Engagement Total for Instagram Posts',
            'abbreviatedExportName': 'Avg. Engagement Total for Posts',
            description: strings.instagram_average_daily_posts_engagement_total_description,
            'iconUrl': iconUrls[source.INSTAGRAM],
            'submetrics': ['INSTAGRAM_AVERAGE_DAILY_POSTS_LIKES', 'INSTAGRAM_AVERAGE_DAILY_POSTS_COMMENTS'],
            'rollupSource': 'instagramTrends',
            'propSummary': 'average_daily_posts_engagement_total',
            'propDaily': 'daily_posts_engagement_total'
        },
        'INSTAGRAM_POSTS_ENGAGEMENT_RATE': {
            'id': 18007,
            'source': source.INSTAGRAM,
            'dataType': dataType.ABSOLUTE_PERCENT,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Instagram Posts Engagement Rate',
            'abbreviatedName': 'Post Engagement Rate',
            'exportName': 'Engagement Rate for Instagram Posts',
            'abbreviatedExportName': 'Engagement Rate for Posts',
            description: strings.instagram_posts_engagement_rate_description,
            'iconUrl': iconUrls[source.INSTAGRAM],
            'rollupSource': 'instagramTrends',
            'propSummary': 'posts_engagement_rate',
            'propDaily': 'daily_posts_engagement_rate'
        },
        'INSTAGRAM_AVERAGE_DAILY_POSTS_ENGAGEMENT_RATE': {
            'id': 18107,
            'source': source.INSTAGRAM,
            'dataType': dataType.ABSOLUTE_PERCENT,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Average Instagram Posts Engagement Rate per Day',
            'abbreviatedName': 'Avg. Post Engagement Rate per Day',
            'exportName': 'Average Daily Engagement Rate for Instagram Posts',
            'abbreviatedExportName': 'Avg. Engagement Rate for Posts',
            description: strings.instagram_average_daily_posts_engagement_rate_description,
            'iconUrl': iconUrls[source.INSTAGRAM],
            'rollupSource': 'instagramTrends',
            'propSummary': 'average_daily_posts_engagement_rate',
            'propDaily': 'daily_posts_engagement_rate'
        },
        'INSTAGRAM_AVERAGE_POST_ENGAGEMENT_TOTAL': {
            'id': 18008,
            'source': source.INSTAGRAM,
            'dataType': dataType.NUMERIC,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Instagram Average Engagement Total per Post',
            'abbreviatedName': 'Avg. Engagement Total per Post',
            'exportName': 'Average Engagement Total per Instagram Post',
            'abbreviatedExportName': 'Avg. Engagement Total per Post',
            description: strings.instagram_average_post_engagement_total_description,
            'iconUrl': iconUrls[source.INSTAGRAM],
            'rollupSource': 'instagramTrends',
            'propSummary': 'average_post_engagement_total',
            'propDaily': 'daily_average_post_engagement_total'
        },
        'INSTAGRAM_AVERAGE_POST_ENGAGEMENT_RATE': {
            'id': 18009,
            'source': source.INSTAGRAM,
            'dataType': dataType.ABSOLUTE_PERCENT,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'apiName': 'Instagram Average Engagement Rate per Post',
            'name': 'Instagram Engagement Rate by Follower',
            'abbreviatedName': 'Engagement Rate by Follower',
            'exportName': 'Instagram Engagement Rate by Follower',
            'abbreviatedExportName': 'Engagement Rate by Follower',
            description: strings.instagram_average_post_engagement_rate_description,
            'iconUrl': iconUrls[source.INSTAGRAM],
            'rollupSource': 'instagramTrends',
            'propSummary': 'average_post_engagement_rate',
            'propDaily': 'daily_average_post_engagement_rate'
        },
        'INSTAGRAM_OVERVIEW': {
            'id': 18010,
            'source': source.INSTAGRAM,
            'dataType': dataType.STRING,
            'category': category.POSITIONING,
            'metricType': metricType.TEXT,
            'name': 'Instagram Bio',
            'abbreviatedName': 'Bio',
            description: strings.instagram_overview_description,
            'iconUrl': iconUrls[source.INSTAGRAM],
            'columns': ['length'],
            'rollupSource': 'instagramTrends',
            'propSummary': 'overview',
            'propDaily': 'overview'
        },
        'INSTAGRAM_FULL_NAME': {
            'id': 18011,
            'source': source.INSTAGRAM,
            'dataType': dataType.STRING,
            'category': category.POSITIONING,
            'metricType': metricType.TEXT,
            'name': 'Instagram Full Name',
            'abbreviatedName': 'Full Name',
            description: strings.instagram_full_name_description,
            'iconUrl': iconUrls[source.INSTAGRAM],
            'columns': ['length'],
            'rollupSource': 'instagramTrends',
            'propSummary': 'full_name',
            'propDaily': 'full_name'
        },
        'INSTAGRAM_FOLLOWERS_FOLLOWING_RATIO': {
            'id': 18013,
            'source': source.INSTAGRAM,
            'dataType': dataType.NUMERIC,
            'category': category.REACH,
            'metricType': metricType.VOLUME,
            'name': 'Instagram Follower to Following Ratio',
            'abbreviatedName': 'Follower/Following Ratio',
            description: strings.instagram_followers_following_ratio_description,
            'iconUrl': iconUrls[source.INSTAGRAM],
            'rollupSource': 'instagramTrends',
            'propSummary': 'followers_to_following',
            'propDaily': 'followers_to_following'
        },
        'INSTAGRAM_ESTIMATED_IMPRESSIONS': {
            'id': 18014,
            'source': source.INSTAGRAM,
            'dataType': dataType.NUMERIC,
            'category': category.REACH,
            'metricType': metricType.VOLUME,
            'name': 'Instagram Estimated Impressions',
            'abbreviatedName': 'Estimated Impressions',
            description: strings.estimated_impressions_description,
            'iconUrl': iconUrls[source.INSTAGRAM],
            'rollupSource': 'instagramTrends',
            'propSummary': 'estimated_impressions',
            'propDaily': 'daily_estimated_impressions'
        },
        'INSTAGRAM_ENGAGEMENT_RATE_BY_ESTIMATED_IMPRESSION': {
            'id': 18015,
            'source': source.INSTAGRAM,
            'dataType': dataType.ABSOLUTE_PERCENT,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Instagram Engagement Rate by Estimated Impression',
            'abbreviatedName': 'Eng. Rate by Est. Impressions',
            description: strings.engagement_rate_by_estimated_impression_description,
            'iconUrl': iconUrls[source.INSTAGRAM],
            'rollupSource': 'instagramTrends',
            'propSummary': 'engagement_rate_by_estimated_impression',
            'propDaily': 'daily_engagement_rate_by_estimated_impression'
        },

        'TIKTOK_FOLLOWERS': {
            'id': 28003,
            'source': source.TIKTOK,
            'dataType': dataType.INTEGER,
            'category': category.REACH,
            'metricType': metricType.TOTAL,
            'name': 'TikTok Followers',
            'abbreviatedName': 'Followers',
            'iconUrl': iconUrls[source.TIKTOK],
            'rollupSource': 'tiktokTrends',
            'propSummary': 'audience',
            'propDaily': 'audience',
            'activityFilter': {
                'include': true,
                'event': {
                    'up': {
                        'relative': 0.1,
                        'absolute': 100
                    },
                    'down': {
                        'relative': 0.1,
                        'absolute': 100
                    },
                    'ignoreZeros': true
                },
                'default': {
                    'up': {
                        'relative': 0.1,
                        'absolute': 100
                    },
                    'down': {
                        'relative': 0.1,
                        'absolute': 100
                    },
                    'ignoreZeros': true
                },
                'scaling': {
                    'up': {
                        'relative': 'standard',
                        'absolute': 'standard'
                    },
                    'down': {
                        'relative': 'standard',
                        'absolute': 'standard'
                    }
                }
            }
        },
        'TIKTOK_POSTS_LIKES': {
            'id': 28004,
            'source': source.TIKTOK,
            'dataType': dataType.INTEGER,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'TikTok Post Likes',
            'abbreviatedName': 'Post Likes',
            'shortName': 'Likes',
            'exportName': 'TikTok Post Like',
            'abbreviatedExportName': 'Post Like',
            description: strings.tiktok_posts_likes_description,
            'iconUrl': iconUrls[source.TIKTOK],
            'rollupSource': 'tiktokTrends',
            'propSummary': 'posts_diggs',
            'propDaily': 'daily_posts_diggs'
        },
        'TIKTOK_POSTS_COMMENTS': {
            'id': 28005,
            'source': source.TIKTOK,
            'dataType': dataType.INTEGER,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'TikTok Post Comments',
            'abbreviatedName': 'Post Comments',
            'shortName': 'Comments',
            'exportName': 'TikTok Post Comment',
            'abbreviatedExportName': 'Post Comment',
            description: strings.tiktok_posts_comments_description,
            'iconUrl': iconUrls[source.TIKTOK],
            'rollupSource': 'tiktokTrends',
            'propSummary': 'posts_comments',
            'propDaily': 'daily_posts_comments'
        },
        'TIKTOK_POSTS_SHARES': {
            'id': 28007,
            'source': source.TIKTOK,
            'dataType': dataType.INTEGER,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'TikTok Post Shares',
            'abbreviatedName': 'Post Shares',
            'shortName': 'Shares',
            'exportName': 'TikTok Post Share',
            'abbreviatedExportName': 'Post Share',
            description: strings.tiktok_posts_shares_description,
            'iconUrl': iconUrls[source.TIKTOK],
            'rollupSource': 'tiktokTrends',
            'propSummary': 'posts_shares',
            'propDaily': 'daily_posts_shares'
        },
        'TIKTOK_POSTS_ENGAGEMENT_TOTAL': {
            'id': 28006,
            'source': source.TIKTOK,
            'dataType': dataType.INTEGER,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'TikTok Posts Engagement Total',
            'abbreviatedName': 'Post Engagement Total',
            'exportName': 'Engagement Total for TikTok Posts',
            'abbreviatedExportName': 'Engagement Total for Posts',
            description: strings.tiktok_posts_engagement_total_description,
            'iconUrl': iconUrls[source.TIKTOK],
            'activityFilter': {
                'include': true,
                'event': {
                    'up': {
                        'relative': 5,
                        'absolute': 100
                    }
                },
                'default': {
                    'up': {
                        'relative': 5,
                        'absolute': 100
                    },
                    'down': {
                        'relative': 5,
                        'absolute': 100
                    }
                },
                'scaling': {
                    'up': {
                        'relative': 'none',
                        'absolute': 'standard'
                    },
                    'down': {
                        'relative': 'none',
                        'absolute': 'standard'
                    }
                }
            },
            'submetrics': ['TIKTOK_POSTS_LIKES', 'TIKTOK_POSTS_COMMENTS', 'TIKTOK_POSTS_SHARES'],
            'rollupSource': 'tiktokTrends',
            'propSummary': 'posts_engagement_total',
            'propDaily': 'daily_posts_engagement_total'
        },
        'TIKTOK_PRESENCE_REACH': {
            'id': 28009,
            'source': source.TIKTOK,
            'dataType': dataType.INTEGER,
            'category': category.REACH,
            'metricType': metricType.TOTAL,
            'name': 'TikTok Followed By',
            'abbreviatedName': 'Followed By',
            description: strings.tiktok_presence_reach_description,
            'iconUrl': iconUrls[source.TIKTOK],
            'dontShowInUi': true,
            'rollupSource': 'tiktokTrends',
            'propSummary': 'presence_reach',
            'propDaily': 'presence_reach'
        },
        'TIKTOK_POSTS': {
            'id': 28010,
            'source': source.TIKTOK,
            'dataType': dataType.INTEGER,
            'category': category.ACTIVITY,
            'metricType': metricType.VOLUME,
            'name': 'TikTok Posts',
            'abbreviatedName': 'Posts',
            'exportName': 'TikTok Post',
            'abbreviatedExportName': 'Post',
            description: strings.tiktok_posts_description,
            'iconUrl': iconUrls[source.TIKTOK],
            'rollupSource': 'tiktokTrends',
            'propSummary': 'posts',
            'propDaily': 'daily_posts'
        },
        'TIKTOK_AVG_COUNT_PER_DAY': {
            'id': 28011,
            'source': source.TIKTOK,
            'dataType': dataType.NUMERIC,
            'metricType': metricType.VOLUME,
            'name': 'avg_posts_per_day',
            'exportName': 'TIKTOK avg_posts_per_day',
            'rollupSource': 'tiktokTrends',
            'propSummary': 'average_daily_posts',
            'propDaily': 'daily_posts'
        },
        'TIKTOK_AVG_COUNT_PER_WEEK': {
            'id': 28012,
            'source': source.TIKTOK,
            'dataType': dataType.NUMERIC,
            'metricType': metricType.VOLUME,
            'name': 'avg_posts_per_week',
            'exportName': 'TIKTOK avg_posts_per_week',
            'rollupSource': 'tiktokTrends',
            'propSummary': 'average_weekly_posts',
            'propDaily': 'average_weekly_posts'
        },
        'TIKTOK_AVG_ENGAGEMENT_RATE_PER_POST': {
            'id': 28013,
            'source': source.TIKTOK,
            'dataType': dataType.NUMERIC,
            'metricType': metricType.VOLUME,
            'name': 'Engagement Rate by Follower',
            'exportName': 'TIKTOK avg_engagement_rate_per_post',
            'rollupSource': 'tiktokTrends',
            'propSummary': 'average_post_engagement_rate',
            'propDaily': 'daily_average_post_engagement_rate'
        },
        'TIKTOK_AVG_ENGAGEMENT_TOTAL_PER_DAY': {
            'id': 28014,
            'source': source.TIKTOK,
            'dataType': dataType.NUMERIC,
            'metricType': metricType.VOLUME,
            'name': 'avg_engagement_total_per_day',
            'exportName': 'TIKTOK avg_engagement_total_per_day',
            'rollupSource': 'tiktokTrends',
            'propSummary': 'average_daily_posts_engagement_total',
            'propDaily': 'daily_posts_engagement_total'
        },
        'TIKTOK_ENGAGEMENT_TOTAL_PER_POST': {
            'id': 28015,
            'source': source.TIKTOK,
            'dataType': dataType.NUMERIC,
            'metricType': metricType.VOLUME,
            'name': 'engagement_total_per_post',
            'exportName': 'TIKTOK engagement_total_per_post',
            'rollupSource': 'tiktokTrends',
            'propSummary': 'average_post_engagement_total',
            'propDaily': 'daily_average_post_engagement_total'
        },
        'TIKTOK_VIEWS': {
            'id': 28016,
            'source': source.TIKTOK,
            'dataType': dataType.INTEGER,
            'metricType': metricType.VOLUME,
            'name': 'TIKTOK views',
            'exportName': 'TIKTOK views',
            'rollupSource': 'tiktokTrends',
            'propSummary': 'posts_views',
            'propDaily': 'daily_posts_views'
        },
        'TIKTOK_VIEWS_PER_POST': {
            'id': 28017,
            'source': source.TIKTOK,
            'dataType': dataType.NUMERIC,
            'metricType': metricType.VOLUME,
            'name': 'views_per_post',
            'exportName': 'TIKTOK views_per_post',
            'rollupSource': 'tiktokTrends',
            'propSummary': 'views_per_post',
            'propDaily': 'daily_views_per_post'
        },
        'TIKTOK_AVG_VIEWS_PER_DAY': {
            'id': 28018,
            'source': source.TIKTOK,
            'dataType': dataType.NUMERIC,
            'metricType': metricType.VOLUME,
            'name': 'avg_views_per_day',
            'exportName': 'TIKTOK avg_views_per_day',
            'rollupSource': 'tiktokTrends',
            'propSummary': 'average_daily_posts_views',
            'propDaily': 'daily_posts_views'
        },
        'TIKTOK_ENGAGEMENT_TOTAL_PER_VIEW': {
            'id': 28019,
            'source': source.TIKTOK,
            'dataType': dataType.NUMERIC,
            'metricType': metricType.VOLUME,
            'name': 'engagement_rate_by_view',
            'exportName': 'TIKTOK engagement_rate_by_view',
            'rollupSource': 'tiktokTrends',
            'propSummary': 'engagement_total_per_view',
            'propDaily': 'daily_engagement_total_per_view'
        },
        'TIKTOK_VIEWS_PER_FOLLOWER': {
            'id': 28020,
            'source': source.TIKTOK,
            'dataType': dataType.NUMERIC,
            'metricType': metricType.VOLUME,
            'name': 'views_per_follower',
            'exportName': 'TIKTOK views_per_follower',
            'rollupSource': 'tiktokTrends',
            'propSummary': 'views_per_follower',
            'propDaily': 'daily_views_per_follower'
        },
        'TIKTOK_OVERVIEW': {
            'id': 28021,
            'source': source.TIKTOK,
            'dataType': dataType.STRING,
            'category': category.POSITIONING,
            'metricType': metricType.TEXT,
            'name': 'TikTok Bio',
            'abbreviatedName': 'Bio',
            'iconUrl': iconUrls[source.TIKTOK],
            'columns': ['length'],
            'rollupSource': 'tiktokTrends',
            'propSummary': 'signature',
            'propDaily': 'signature'
        },
        'TIKTOK_ESTIMATED_IMPRESSIONS': {
            'id': 28022,
            'source': source.TIKTOK,
            'dataType': dataType.NUMERIC,
            'category': category.REACH,
            'metricType': metricType.VOLUME,
            'name': 'TikTok Estimated Impressions',
            'abbreviatedName': 'Estimated Impressions',
            description: strings.estimated_impressions_description,
            'iconUrl': iconUrls[source.TIKTOK],
            'rollupSource': 'tiktokTrends',
            'propSummary': 'estimated_impressions',
            'propDaily': 'daily_estimated_impressions'
        },
        'TIKTOK_ENGAGEMENT_RATE_BY_ESTIMATED_IMPRESSION': {
            'id': 28023,
            'source': source.TIKTOK,
            'dataType': dataType.ABSOLUTE_PERCENT,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'TikTok Engagement Rate by Estimated Impression',
            'abbreviatedName': 'Eng. Rate by Est. Impressions',
            description: strings.engagement_rate_by_estimated_impression_description,
            'iconUrl': iconUrls[source.TIKTOK],
            'rollupSource': 'tiktokTrends',
            'propSummary': 'engagement_rate_by_estimated_impression',
            'propDaily': 'daily_engagement_rate_by_estimated_impression'
        },

        'WEB_HOMEPAGE_TITLE': {
            'id': 15000,
            'source': source.WEB,
            'dataType': dataType.STRING,
            'category': category.POSITIONING,
            'metricType': metricType.TEXT,
            'name': 'Homepage Title',
            description: strings.web_homepage_title_description,
            'iconUrl': iconUrls[source.WEB],
            'columns': ['length'],
            'rollupSource': 'urlExtractedDataTrends',
            'propSummary': 'title',
            'propDaily': 'title'
        },
        'WEB_HOMEPAGE_META_DESCRIPTION': {
            'id': 15001,
            'source': source.WEB,
            'dataType': dataType.STRING,
            'category': category.POSITIONING,
            'metricType': metricType.TEXT,
            'name': 'Homepage Meta Description',
            description: strings.web_homepage_meta_description_description,
            'iconUrl': iconUrls[source.WEB],
            'columns': ['length', 'metaDescriptionLengthQuality'],
            'rollupSource': 'urlExtractedDataTrends',
            'propSummary': 'meta_description',
            'propDaily': 'meta_description'
        },
        'WEB_HOMEPAGE_META_KEYWORDS': {
            'id': 15002,
            'source': source.WEB,
            'dataType': dataType.STRING,
            'category': category.POSITIONING,
            'metricType': metricType.TEXT,
            'name': 'Homepage Meta Keywords',
            description: strings.web_homepage_meta_keywords_description,
            'iconUrl': iconUrls[source.WEB],
            'rollupSource': 'urlExtractedDataTrends',
            'propSummary': 'meta_keywords'
        },
        'CROSS_CHANNEL_AUDIENCE': {
            'id': 16002,
            'source': source.CROSS_CHANNEL,
            'dataType': dataType.INTEGER,
            'category': category.REACH,
            'metricType': metricType.TOTAL,
            'name': 'Social Audience',
            'abbreviatedName': 'Social Audience',
            description: strings.cross_channel_audience_description,
            'iconUrl': iconUrls[source.CROSS_CHANNEL],
            'submetrics': ['TWITTER_FOLLOWERS', 'FACEBOOK_LIKES', 'YOUTUBE_SUBSCRIBERS', 'INSTAGRAM_FOLLOWED_BY'],
            'useSourceNameForSubmetricLegend': true,
            'rollupSource': 'metaTrends',
            'propSummary': 'audience',
            'propDaily': 'audience'
        },
        'CROSS_CHANNEL_ACTIVITY': {
            'id': 16004,
            'source': source.CROSS_CHANNEL,
            'dataType': dataType.INTEGER,
            'category': category.ACTIVITY,
            'metricType': metricType.VOLUME,
            'name': 'Social Activity',
            'abbreviatedName': 'Social Activity',
            description: strings.cross_channel_activity_description,
            'iconUrl': iconUrls[source.CROSS_CHANNEL],
            'submetrics': ['TWITTER_NORMAL_TWEETS', 'FACEBOOK_POSTS', 'YOUTUBE_POSTS', 'INSTAGRAM_POSTS'],
            'useSourceNameForSubmetricLegend': true,
            'rollupSource': 'metaTrends',
            'propSummary': 'total_activity',
            'propDaily': 'total_activity'
        },
        'CROSS_CHANNEL_ENGAGEMENT': {
            'id': 16006,
            'source': source.CROSS_CHANNEL,
            'dataType': dataType.INTEGER,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Social Engagement',
            'abbreviatedName': 'Social Engagement',
            description: strings.cross_channel_engagement_description,
            'iconUrl': iconUrls[source.CROSS_CHANNEL],
            'submetrics': ['TWITTER_TWEETS_ENGAGEMENT_TOTAL', 'FACEBOOK_POSTS_ENGAGEMENT_TOTAL', 'YOUTUBE_POSTS_ENGAGEMENT_TOTAL', 'INSTAGRAM_POSTS_ENGAGEMENT_TOTAL'],
            'useSourceNameForSubmetricLegend': true,
            'rollupSource': 'metaTrends',
            'propSummary': 'total_engagement',
            'propDaily': 'total_engagement'
        },
        'CROSS_CHANNEL_APPLAUSE': {
            'id': 16008,
            'source': source.CROSS_CHANNEL,
            'dataType': dataType.INTEGER,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Social Applause Engagement',
            'abbreviatedName': 'Social Applause',
            description: strings.cross_channel_applause_description,
            'iconUrl': iconUrls[source.CROSS_CHANNEL],
            'submetrics': ['TWITTER_TWEETS_FAVORITES', 'FACEBOOK_POSTS_REACTIONS', 'YOUTUBE_POSTS_LIKES', 'INSTAGRAM_POSTS_LIKES'],
            'useSourceNameForSubmetricLegend': true,
            'rollupSource': 'metaTrends',
            'propSummary': 'total_applause',
            'propDaily': 'total_applause'
        },
        'CROSS_CHANNEL_CONVERSATION': {
            'id': 16010,
            'source': source.CROSS_CHANNEL,
            'dataType': dataType.INTEGER,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Social Conversation Engagement',
            'abbreviatedName': 'Social Conversation',
            description: strings.cross_channel_conversation_description,
            'iconUrl': iconUrls[source.CROSS_CHANNEL],
            'submetrics': ['TWITTER_TWEETS_REPLIES', 'FACEBOOK_POSTS_COMMENTS', 'YOUTUBE_POSTS_COMMENTS', 'INSTAGRAM_POSTS_COMMENTS'],
            'useSourceNameForSubmetricLegend': true,
            'rollupSource': 'metaTrends',
            'propSummary': 'total_conversation',
            'propDaily': 'total_conversation'
        },
        'CROSS_CHANNEL_AMPLIFICATION': {
            'id': 16012,
            'source': source.CROSS_CHANNEL,
            'dataType': dataType.INTEGER,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Social Amplification Engagement',
            'abbreviatedName': 'Social Amplification',
            description: strings.cross_channel_amplification_description,
            'iconUrl': iconUrls[source.CROSS_CHANNEL],
            'submetrics': ['TWITTER_TWEETS_RETWEETS', 'FACEBOOK_POSTS_SHARES'],
            'useSourceNameForSubmetricLegend': true,
            'rollupSource': 'metaTrends',
            'propSummary': 'total_amplification',
            'propDaily': 'total_amplification'
        },
        'CROSS_CHANNEL_AVG_ENGAGEMENT_RATE_PER_POST': {
            'id': 16014,
            'source': source.CROSS_CHANNEL,
            'dataType': dataType.ABSOLUTE_PERCENT,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'apiName': 'Cross Channel Average Engagement Rate per Post',
            'name': 'Engagement Rate by Follower',
            'abbreviatedName': 'Engagement Rate by Follower',
            valueFormat: formatter.absolutePercent,
            description: strings.cross_channel_avg_engagement_rate_per_post_description,
            'iconUrl': iconUrls[source.CROSS_CHANNEL],
            'rollupSource': 'metaTrends',
            'propSummary': 'avg_engagement_rate_per_post',
            'propDaily': 'avg_engagement_rate_per_post'
        },
        'CROSS_CHANNEL_ESTIMATED_IMPRESSIONS': {
            'id': 16015,
            'source': source.CROSS_CHANNEL,
            'dataType': dataType.NUMERIC,
            'category': category.REACH,
            'metricType': metricType.VOLUME,
            'name': 'Cross Channel Estimated Impressions',
            'abbreviatedName': 'Estimated Impressions',
            description: strings.estimated_impressions_description,
            'iconUrl': iconUrls[source.CROSS_CHANNEL],
            'rollupSource': 'metaTrends',
            'propSummary': 'estimated_impressions',
            'propDaily': 'daily_estimated_impressions'
        },
        'CROSS_CHANNEL_ENGAGEMENT_RATE_BY_ESTIMATED_IMPRESSION': {
            'id': 16016,
            'source': source.CROSS_CHANNEL,
            'dataType': dataType.ABSOLUTE_PERCENT,
            'category': category.ENGAGEMENT,
            'metricType': metricType.VOLUME,
            'name': 'Cross Channel Engagement Rate by Estimated Impression',
            'abbreviatedName': 'Eng. Rate by Est. Impressions',
            description: strings.engagement_rate_by_estimated_impression_description,
            'iconUrl': iconUrls[source.CROSS_CHANNEL],
            'rollupSource': 'metaTrends',
            'propSummary': 'engagement_rate_by_estimated_impression',
            'propDaily': 'daily_engagement_rate_by_estimated_impression'
        }
    };

    function addMetricDescription(name, source, config) {

        const metricDescription = metricDescriptions[name] = _.defaults(config, {
            source: source,
            iconUrl: iconUrls[source]
        });

        return metricDescription;
    }

    // Facebook Metrics
    addFacebookMetricDescription('LIKES', {
        'dataType': dataType.INTEGER,
        'category': category.REACH,
        'metricType': metricType.TOTAL,
        'name': 'Facebook Page Likes',
        'abbreviatedName': 'Page Likes',
        description: strings.facebook_likes_description,
        'activityFilter': {
            'include': true,
            'event': {
                'up': {
                    'relative': 0.1,
                    'absolute': 100
                },
                'down': {
                    'relative': 0.1,
                    'absolute': 100
                },
                'ignoreZeros': true
            },
            'default': {
                'up': {
                    'relative': 0.1,
                    'absolute': 100
                },
                'down': {
                    'relative': 0.1,
                    'absolute': 100
                },
                'ignoreZeros': true
            },
            'scaling': {
                'up': {
                    'relative': 'standard',
                    'absolute': 'standard'
                },
                'down': {
                    'relative': 'standard',
                    'absolute': 'standard'
                }
            }
        },
        'propSummary': 'audience',
        'propDaily': 'audience'
    });

    addFacebookMetricDescription('POSTS', {
        'dataType': dataType.INTEGER,
        'category': category.ACTIVITY,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Posts',
        'abbreviatedName': 'Posts',
        'exportName': 'Facebook Post',
        'abbreviatedExportName': 'Post',
        description: strings.facebook_posts_description,
        'propSummary': 'posts',
        'propDaily': 'daily_posts'
    });

    addFacebookMetricDescription('AVERAGE_DAILY_POSTS', {
        'id': 11101,
        'dataType': dataType.NUMERIC,
        'category': category.ACTIVITY,
        'metricType': metricType.VOLUME,
        'name': 'Average Facebook Posts per Day',
        'abbreviatedName': 'Avg. Posts per Day',
        'exportName': 'Average Daily Facebook Post',
        'abbreviatedExportName': 'Avg. Daily Post',
        description: strings.facebook_average_daily_posts_description,
        'propSummary': 'average_daily_posts',
        'propDaily': 'daily_posts'
    });

    addFacebookMetricDescription('POSTS_LIKES', {
        'source': source.FACEBOOK,
        'dataType': dataType.INTEGER,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Post Likes',
        'abbreviatedName': 'Post Likes',
        'shortName': 'Likes',
        'exportName': 'Facebook Post Like',
        'abbreviatedExportName': 'Post Like',
        description: strings.facebook_posts_likes_description,
        'propSummary': 'posts_likes',
        'propDaily': 'daily_posts_likes'
    });

    addFacebookMetricDescription('AVERAGE_DAILY_POSTS_LIKES', {
        'id': 11102,
        'dataType': dataType.NUMERIC,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Average Facebook Post Likes per Day',
        'abbreviatedName': 'Likes/Day',
        'exportName': 'Average Daily Facebook Post Like',
        'abbreviatedExportName': 'Avg. Daily Post Like',
        description: strings.facebook_average_daily_posts_likes_description,
        'propSummary': 'average_daily_posts_likes',
        'propDaily': 'daily_posts_likes'
    });

    addFacebookMetricDescription('POSTS_COMMENTS', {
        'dataType': dataType.INTEGER,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Post Comments',
        'abbreviatedName': 'Post Comments',
        'shortName': 'Comments',
        'exportName': 'Facebook Post Comment',
        'abbreviatedExportName': 'Post Comment',
        description: strings.facebook_posts_comments_description,
        'propSummary': 'posts_comments',
        'propDaily': 'daily_posts_comments'
    });

    addFacebookMetricDescription('AVERAGE_DAILY_POSTS_COMMENTS', {
        'id': 11103,
        'dataType': dataType.NUMERIC,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Average Facebook Post Comments per Day',
        'abbreviatedName': 'Avg. Post Comments per Day',
        'exportName': 'Average Daily Facebook Post Comment',
        'abbreviatedExportName': 'Avg. Daily Post Comment',
        description: strings.facebook_average_daily_posts_comments_description,
        'propSummary': 'average_daily_posts_comments',
        'propDaily': 'daily_posts_comments'
    });

    addFacebookMetricDescription('POSTS_SHARES', {
        'dataType': dataType.INTEGER,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Post Shares',
        'abbreviatedName': 'Post Shares',
        'shortName': 'Shares',
        'exportName': 'Facebook Post Share',
        'abbreviatedExportName': 'Post Share',
        description: strings.facebook_posts_shares_description,
        'propSummary': 'posts_shares',
        'propDaily': 'daily_posts_shares'
    });

    addFacebookMetricDescription('AVERAGE_DAILY_POSTS_SHARES', {
        'id': 11104,
        'dataType': dataType.NUMERIC,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Average Facebook Post Shares per Day',
        'abbreviatedName': 'Avg. Post Shares per Day',
        'exportName': 'Average Daily Facebook Post Share',
        'abbreviatedExportName': 'Avg. Daily Post Share',
        description: strings.facebook_average_daily_posts_shares_description,
        'propSummary': 'average_daily_posts_shares',
        'propDaily': 'daily_posts_shares'
    });

    addFacebookMetricDescription('POSTS_ENGAGEMENT_TOTAL', {
        'dataType': dataType.INTEGER,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Post Engagement Total',
        'abbreviatedName': 'Post Engagement Total',
        'exportName': 'Engagement Total for Facebook Posts',
        'abbreviatedExportName': 'Engagement Total for Posts',
        description: strings.facebook_posts_engagement_total_description,
        'activityFilter': {
            'include': true,
            'event': {
                'up': {
                    'relative': 5,
                    'absolute': 100
                }
            },
            'default': {
                'up': {
                    'relative': 5,
                    'absolute': 100
                },
                'down': {
                    'relative': 5,
                    'absolute': 100
                }
            },
            'scaling': {
                'up': {
                    'relative': 'none',
                    'absolute': 'standard'
                },
                'down': {
                    'relative': 'none',
                    'absolute': 'standard'
                }
            }
        },
        'submetrics': ['FACEBOOK_POSTS_REACTIONS', 'FACEBOOK_POSTS_COMMENTS', 'FACEBOOK_POSTS_SHARES'],
        'propSummary': 'posts_engagement_total',
        'propDaily': 'daily_posts_engagement_total'
    });

    addFacebookMetricDescription('AVERAGE_DAILY_POSTS_ENGAGEMENT_TOTAL', {
        'id': 11105,
        'dataType': dataType.NUMERIC,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Average Facebook Post Engagement Total per Day',
        'abbreviatedName': 'Avg. Post Engagement Total',
        'exportName': 'Average Daily Engagement Total for Facebook Posts',
        'abbreviatedExportName': 'Avg. Engagement Total for Posts',
        description: strings.facebook_average_daily_posts_engagement_total_description,
        'submetrics': ['FACEBOOK_AVERAGE_DAILY_POSTS_REACTIONS', 'FACEBOOK_AVERAGE_DAILY_POSTS_COMMENTS', 'FACEBOOK_AVERAGE_DAILY_POSTS_SHARES'],
        'propSummary': 'average_daily_posts_engagement_total',
        'propDaily': 'daily_posts_engagement_total'
    });

    addFacebookMetricDescription('POSTS_ENGAGEMENT_RATE', {
        'dataType': dataType.ABSOLUTE_PERCENT,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Post Engagement Rate',
        'abbreviatedName': 'Post Engagement Rate',
        'exportName': 'Engagement Rate for Facebook Posts',
        'abbreviatedExportName': 'Engagement Rate for Posts',
        description: strings.facebook_posts_engagement_rate_description,
        'propSummary': 'posts_engagement_rate',
        'propDaily': 'daily_posts_engagement_rate'
    });

    addFacebookMetricDescription('AVERAGE_DAILY_POSTS_ENGAGEMENT_RATE', {
        'id': 11106,
        'dataType': dataType.ABSOLUTE_PERCENT,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Average Facebook Post Engagement Rate per Day',
        'abbreviatedName': 'Avg. Engagement Rate',
        'exportName': 'Average Daily Engagement Rate for Facebook Posts',
        'abbreviatedExportName': 'Avg. Engagement Rate for Posts',
        description: strings.facebook_average_daily_posts_engagement_rate_description,
        'propSummary': 'average_daily_posts_engagement_rate',
        'propDaily': 'daily_posts_engagement_rate'
    });

    addFacebookMetricDescription('AVERAGE_POST_ENGAGEMENT_TOTAL', {
        'dataType': dataType.NUMERIC,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Average Engagement Total per Post',
        'abbreviatedName': 'Avg. Engagement Total per Post',
        'exportName': 'Average Engagement Total per Facebook Post',
        'abbreviatedExportName': 'Avg. Engagement Total per Post',
        description: strings.facebook_average_post_engagement_total_description,
        'iconUrl': iconUrls[source.FACEBOOK],
        'propSummary': 'average_post_engagement_total',
        'propDaily': 'daily_average_post_engagement_total'
    });

    addFacebookMetricDescription('AVERAGE_POST_ENGAGEMENT_RATE', {
        'dataType': dataType.ABSOLUTE_PERCENT,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'apiName': 'Facebook Average Engagement Rate per Post',
        'name': 'Facebook Engagement Rate by Page Fan',
        'abbreviatedName': 'Engagement Rate by Page Fan',
        'exportName': 'Facebook Engagement Rate by Page Fan',
        'abbreviatedExportName': 'Engagement Rate by Page Fan',
        description: strings.facebook_average_post_engagement_rate_description,
        'propSummary': 'average_post_engagement_rate',
        'propDaily': 'daily_average_post_engagement_rate'
    });

    addFacebookMetricDescription('TALKING_ABOUT', {
        'dataType': dataType.INTEGER,
        'category': category.ENGAGEMENT,
        'metricType': metricType.TOTAL,
        'name': 'Facebook Talking About',
        'abbreviatedName': 'Talking About',
        description: strings.facebook_talking_about_description,
        'propSummary': 'talking_about',
        'propDaily': 'talking_about'
    });

    addFacebookMetricDescription('OVERVIEW', {
        'dataType': dataType.STRING,
        'category': category.POSITIONING,
        'metricType': metricType.TEXT,
        'name': 'Facebook Description',
        description: strings.facebook_overview_description,
        'abbreviatedName': 'Description',
        'columns': ['length'],
        'propSummary': 'overview',
        'propDaily': 'overview'
    });

    addFacebookMetricDescription('PRESENCE_REACH', {
        'dataType': dataType.INTEGER,
        'category': category.REACH,
        'metricType': metricType.TOTAL,
        'name': 'Facebook Page Likes',
        'abbreviatedName': 'Page Likes',
        description: strings.facebook_presence_reach_description,
        'propSummary': 'presence_reach',
        'propDaily': 'presence_reach',
        'dontShowInUi': true
    });

    addFacebookMetricDescription('POSTS_REACTIONS', {
        'id': 11107,
        'dataType': dataType.INTEGER,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Post Reactions',
        'abbreviatedName': 'Post Reactions',
        'shortName': 'Reactions',
        'exportName': 'Facebook Post Reaction',
        'abbreviatedExportName': 'Post Reaction',
        description: strings.facebook_posts_reactions_description,
        'submetrics': [
            'FACEBOOK_POSTS_LIKES',
            'FACEBOOK_POSTS_LOVES',
            'FACEBOOK_POSTS_HAHAS',
            'FACEBOOK_POSTS_WOWS',
            'FACEBOOK_POSTS_SADS',
            'FACEBOOK_POSTS_ANGRYS'
        ],
        'propSummary': 'posts_reactions',
        'propDaily': 'daily_posts_reactions'
    });

    addFacebookMetricDescription('AVERAGE_DAILY_POSTS_REACTIONS', {
        'id': 11108,
        'dataType': dataType.NUMERIC,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Average Facebook Post Reactions per Day',
        'abbreviatedName': 'Avg. Post Reactions per Day',
        'exportName': 'Average Daily Facebook Post Reaction',
        'abbreviatedExportName': 'Avg. Daily Post Reaction',
        description: strings.facebook_average_daily_posts_reactions_description,
        'submetrics': [
            'FACEBOOK_AVERAGE_DAILY_POSTS_LIKES',
            'FACEBOOK_AVERAGE_DAILY_POSTS_LOVES',
            'FACEBOOK_AVERAGE_DAILY_POSTS_HAHAS',
            'FACEBOOK_AVERAGE_DAILY_POSTS_WOWS',
            'FACEBOOK_AVERAGE_DAILY_POSTS_SADS',
            'FACEBOOK_AVERAGE_DAILY_POSTS_ANGRYS'
        ],
        'propSummary': 'average_daily_posts_reactions',
        'propDaily': 'daily_posts_reactions'
    });

    addFacebookMetricDescription('POSTS_LOVES', {
        'id': 11109,
        'dataType': dataType.INTEGER,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Post Loves',
        'abbreviatedName': 'Post Loves',
        'shortName': 'Loves',
        'exportName': 'Facebook Post Love',
        'abbreviatedExportName': 'Post Love',
        description: strings.facebook_posts_loves_description,
        'propSummary': 'posts_loves',
        'propDaily': 'daily_posts_loves'
    });

    addFacebookMetricDescription('AVERAGE_DAILY_POSTS_LOVES', {
        'id': 11110,
        'dataType': dataType.NUMERIC,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Average Facebook Post Loves per Day',
        'abbreviatedName': 'Loves/Day',
        'exportName': 'Average Daily Facebook Post Love',
        'abbreviatedExportName': 'Avg. Daily Post Love',
        description: strings.facebook_average_daily_posts_loves_description,
        'propSummary': 'average_daily_posts_loves',
        'propDaily': 'daily_posts_loves'
    });

    addFacebookMetricDescription('POSTS_HAHAS', {
        'id': 11111,
        'dataType': dataType.INTEGER,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Post Hahas',
        'abbreviatedName': 'Post Hahas',
        'shortName': 'Hahas',
        'exportName': 'Facebook Post Haha',
        'abbreviatedExportName': 'Post Haha',
        description: strings.facebook_posts_hahas_description,
        'propSummary': 'posts_hahas',
        'propDaily': 'daily_posts_hahas'
    });

    addFacebookMetricDescription('AVERAGE_DAILY_POSTS_HAHAS', {
        'id': 11112,
        'dataType': dataType.NUMERIC,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Average Facebook Post Hahas per Day',
        'abbreviatedName': 'Hahas/Day',
        'exportName': 'Average Daily Facebook Post Haha',
        'abbreviatedExportName': 'Avg. Daily Post Haha',
        description: strings.facebook_average_daily_posts_hahas_description,
        'propSummary': 'average_daily_posts_hahas',
        'propDaily': 'daily_posts_hahas'
    });

    addFacebookMetricDescription('POSTS_WOWS', {
        'id': 11113,
        'dataType': dataType.INTEGER,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Post Wows',
        'abbreviatedName': 'Post Wows',
        'shortName': 'Wows',
        'exportName': 'Facebook Post Wow',
        'abbreviatedExportName': 'Post Wow',
        description: strings.facebook_posts_wows_description,
        'propSummary': 'posts_wows',
        'propDaily': 'daily_posts_wows'
    });

    addFacebookMetricDescription('AVERAGE_DAILY_POSTS_WOWS', {
        'id': 11114,
        'dataType': dataType.NUMERIC,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Average Facebook Post Wows per Day',
        'abbreviatedName': 'Wows/Day',
        'exportName': 'Average Daily Facebook Post Wow',
        'abbreviatedExportName': 'Avg. Daily Post Wow',
        description: strings.facebook_average_daily_posts_wows_description,
        'propSummary': 'average_daily_posts_wows',
        'propDaily': 'daily_posts_wows'
    });

    addFacebookMetricDescription('POSTS_SADS', {
        'id': 11115,
        'dataType': dataType.INTEGER,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Post Sads',
        'abbreviatedName': 'Post Sads',
        'shortName': 'Sads',
        'exportName': 'Facebook Post Sad',
        'abbreviatedExportName': 'Post Sad',
        description: strings.facebook_posts_sads_description,
        'propSummary': 'posts_sads',
        'propDaily': 'daily_posts_sads'
    });

    addFacebookMetricDescription('AVERAGE_DAILY_POSTS_SADS', {
        'id': 11116,
        'dataType': dataType.NUMERIC,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Average Facebook Post Sads per Day',
        'abbreviatedName': 'Sads/Day',
        'exportName': 'Average Daily Facebook Post Sad',
        'abbreviatedExportName': 'Avg. Daily Post Sad',
        description: strings.facebook_average_daily_posts_sads_description,
        'propSummary': 'average_daily_posts_sads',
        'propDaily': 'daily_posts_sads'
    });

    addFacebookMetricDescription('POSTS_ANGRYS', {
        'id': 11117,
        'dataType': dataType.INTEGER,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Post Angrys',
        'abbreviatedName': 'Post Angrys',
        'shortName': 'Angrys',
        'exportName': 'Facebook Post Angry',
        'abbreviatedExportName': 'Post Angry',
        description: strings.facebook_posts_angrys_description,
        'propSummary': 'posts_angrys',
        'propDaily': 'daily_posts_angrys'
    });

    addFacebookMetricDescription('AVERAGE_DAILY_POSTS_ANGRYS', {
        'id': 11118,
        'dataType': dataType.NUMERIC,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Average Facebook Post Angrys per Day',
        'abbreviatedName': 'Angrys/Day',
        'exportName': 'Average Daily Facebook Post Angry',
        'abbreviatedExportName': 'Avg. Daily Post Angry',
        description: strings.facebook_average_daily_posts_angrys_description,
        'propSummary': 'average_daily_posts_angrys',
        'propDaily': 'daily_posts_angrys'
    });

    addFacebookMetricDescription('LIKELY_PROMOTED_POSTS', {
        'id': 11119,
        'dataType': dataType.INTEGER,
        'category': category.REACH,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Likely Boosted Posts',
        'abbreviatedName': 'Likely Boosted Posts',
        'exportName': 'Facebook Likely Boosted Post',
        'abbreviatedExportName': 'Likely Boosted Post',
        description: strings.facebook_likely_promoted_posts_description,
        'propSummary': 'likely_promoted_posts',
        'propDaily': 'daily_likely_promoted_posts'
    });

    addFacebookMetricDescription('ESTIMATED_IMPRESSIONS', {
        'id': 11120,
        'dataType': dataType.NUMERIC,
        'category': category.REACH,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Estimated Impressions',
        'abbreviatedName': 'Estimated Impressions',
        'exportName': 'Facebook Estimated Impressions',
        'abbreviatedExportName': 'Estimated Impressions',
        description: strings.estimated_impressions_description,
        'propSummary': 'estimated_impressions',
        'propDaily': 'daily_estimated_impressions'
    });

    addFacebookMetricDescription('ENGAGEMENT_RATE_BY_ESTIMATED_IMPRESSION', {
        'id': 11121,
        'dataType': dataType.ABSOLUTE_PERCENT,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Engagement Rate by Estimated Impression',
        'abbreviatedName': 'Eng. Rate by Est. Impressions',
        'exportName': 'Facebook Eng. Rate by Est. Impressions',
        'abbreviatedExportName': 'Eng. Rate by Est. Impressions',
        description: strings.engagement_rate_by_estimated_impression_description,
        'propSummary': 'engagement_rate_by_estimated_impression',
        'propDaily': 'daily_engagement_rate_by_estimated_impression'
    });

    addFacebookMetricDescription('POST_VIEWS', {
        'id': 11122,
        'dataType': dataType.INTEGER,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Post Views',
        'abbreviatedName': 'Post Views',
        'exportName': 'Facebook Post Views',
        'abbreviatedExportName': 'Post Views',
        description: strings.facebook_video_post_views_description,
        'propSummary': 'post_views',
        'propDaily': 'daily_post_views'
    });

    // Facebook Insights Metrics
    addFacebookInsightsMetricDescription('IMPRESSIONS', {
        'dataType': dataType.INTEGER,
        'category': category.REACH,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Page Impressions',
        'abbreviatedName': 'Page Impressions',
        description: strings.facebook_insights_glance_impressions_description,
        'propSummary': 'page_impressions',
        'propDaily': 'page_impressions'
    });

    addFacebookInsightsMetricDescription('IMPRESSIONS_PER_DAY', {
        'dataType': dataType.INTEGER,
        'category': category.REACH,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Presence Impressions / Day',
        'abbreviatedName': 'Presence Impressions / Day',
        description: strings.facebook_insights_glance_impressions_per_day_description,
        'propSummary': 'impressions_per_day',
        'propDaily': 'impressions_per_day'
    });

    addFacebookInsightsMetricDescription('IMPRESSIONS_UNIQUE', {
        'dataType': dataType.NUMERIC,
        'category': category.REACH,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Avg. Daily Page Reach (Unique Impressions)',
        'abbreviatedName': 'Avg. Daily Page Reach (Unique Impressions)',
        description: strings.facebook_insights_impressions_unique_description,
        'propSummary': 'average_daily_page_impressions_unique',
        'propDaily': 'page_impressions_unique'
    });

    addFacebookInsightsMetricDescription('IMPRESSIONS_ORGANIC', {
        'dataType': dataType.INTEGER,
        'category': category.REACH,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Organic Page Impressions',
        'abbreviatedName': 'Organic Page Impressions',
        description: strings.facebook_insights_impressions_organic_description,
        'propSummary': 'page_impressions_organic',
        'propDaily': 'page_impressions_organic'
    });

    addFacebookInsightsMetricDescription('IMPRESSIONS_ORGANIC_UNIQUE', {
        'dataType': dataType.NUMERIC,
        'category': category.REACH,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Avg. Daily Organic Page Reach (Unique Impressions)',
        'abbreviatedName': 'Avg. Daily Organic Page Reach (Unique Impressions)',
        description: strings.facebook_insights_impressions_organic_unique_description,
        'propSummary': 'average_daily_page_impressions_organic_unique',
        'propDaily': 'page_impressions_organic_unique'
    });

    addFacebookInsightsMetricDescription('IMPRESSIONS_PAID', {
        'dataType': dataType.INTEGER,
        'category': category.REACH,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Paid Page Impressions',
        'abbreviatedName': 'Paid Page Impressions',
        description: strings.facebook_insights_impressions_paid_description,
        'propSummary': 'page_impressions_paid',
        'propDaily': 'page_impressions_paid'
    });

    addFacebookInsightsMetricDescription('IMPRESSIONS_PAID_UNIQUE', {
        'dataType': dataType.NUMERIC,
        'category': category.REACH,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Avg. Daily Paid Page Reach (Unique Impressions)',
        'abbreviatedName': 'Avg. Daily Paid Page Reach (Unique Impressions)',
        description: strings.facebook_insights_impressions_paid_unique_description,
        'propSummary': 'average_daily_page_impressions_paid_unique',
        'propDaily': 'page_impressions_paid_unique'
    });

    addFacebookInsightsMetricDescription('IMPRESSIONS_VIRAL', {
        'dataType': dataType.INTEGER,
        'category': category.REACH,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Viral Page Impressions',
        'abbreviatedName': 'Viral Page Impressions',
        description: strings.facebook_insights_impressions_viral_description,
        'propSummary': 'page_impressions_viral',
        'propDaily': 'page_impressions_viral'
    });

    addFacebookInsightsMetricDescription('IMPRESSIONS_NONVIRAL_UNIQUE', {
        'dataType': dataType.NUMERIC,
        'category': category.REACH,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Avg. Daily Non-Viral Page Reach (Unique Impressions)',
        'abbreviatedName': 'Avg. Daily Non-Viral Page Reach (Unique Impressions)',
        description: strings.facebook_insights_impressions_viral_unique_description,
        'propSummary': 'average_daily_page_impressions_nonviral_unique',
        'propDaily': 'page_impressions_nonviral_unique'
    });

    addFacebookInsightsMetricDescription('CONSUMPTIONS', {
        'dataType': dataType.INTEGER,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Page Consumptions',
        'abbreviatedName': 'Page Consumptions',
        description: strings.facebook_insights_consumptions_description,
        'propSummary': 'page_consumptions',
        'propDaily': 'page_consumptions'
    });

    addFacebookInsightsMetricDescription('CONSUMPTIONS_PHOTO_VIEWS', {
        'dataType': dataType.INTEGER,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Page Photo View Consumptions',
        'abbreviatedName': 'Page Photo View Consumptions',
        description: strings.facebook_insights_consumptions_photo_views_description,
        'propSummary': 'page_consumptions_by_consumption_type.submetrics.photo view.value',
        'propDaily': 'page_consumptions_by_consumption_type.submetrics.photo view.value'
    });

    addFacebookInsightsMetricDescription('CONSUMPTIONS_OTHER_CLICKS', {
        'dataType': dataType.INTEGER,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Page Click Consumptions',
        'abbreviatedName': 'Page Click Consumptions',
        description: strings.facebook_insights_consumptions_other_clicks_description,
        'propSummary': 'page_consumptions_by_consumption_type.submetrics.other clicks.value',
        'propDaily': 'page_consumptions_by_consumption_type.submetrics.other clicks.value'
    });

    addFacebookInsightsMetricDescription('CONSUMPTIONS_VIDEO_PLAY', {
        'dataType': dataType.INTEGER,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Page Video Play Consumptions',
        'abbreviatedName': 'Page Video Play Consumptions',
        description: strings.facebook_insights_consumptions_video_play_description,
        'propSummary': 'page_consumptions_by_consumption_type.submetrics.video play.value',
        'propDaily': 'page_consumptions_by_consumption_type.submetrics.video play.value'
    });

    addFacebookInsightsMetricDescription('CONSUMPTIONS_LINK_CLICKS', {
        'dataType': dataType.INTEGER,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Page Link Click Consumptions',
        'abbreviatedName': 'Page Link Click Consumptions',
        description: strings.facebook_insights_consumptions_link_clicks_description,
        'propSummary': 'page_consumptions_by_consumption_type.submetrics.link clicks.value',
        'propDaily': 'page_consumptions_by_consumption_type.submetrics.link clicks.value'
    });

    addFacebookInsightsMetricDescription('CONSUMPTIONS_UNIQUE', {
        'dataType': dataType.NUMERIC,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Avg. Daily Unique Page Consumptions',
        'abbreviatedName': 'Avg. Daily Unique Page Consumptions',
        description: strings.facebook_insights_consumptions_unique_description,
        'propSummary': 'average_daily_page_consumptions_unique',
        'propDaily': 'page_consumptions_unique'
    });

    addFacebookInsightsMetricDescription('CONSUMPTIONS_PHOTO_VIEWS_UNIQUE', {
        'dataType': dataType.NUMERIC,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Avg. Daily Unique Photo View Consumptions',
        'abbreviatedName': 'Avg. Daily Unique Photo View Consumptions',
        description: strings.facebook_insights_consumptions_photo_views_unique_description,
        'propSummary': 'average_daily_page_consumptions_by_consumption_type_unique.submetrics.photo view.value',
        'propDaily': 'page_consumptions_by_consumption_type_unique.submetrics.photo view.value'
    });

    addFacebookInsightsMetricDescription('CONSUMPTIONS_OTHER_CLICKS_UNIQUE', {
        'dataType': dataType.NUMERIC,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Avg. Daily Unique Other Click Consumptions',
        'abbreviatedName': 'Avg. Daily Unique Other Click Consumptions',
        description: strings.facebook_insights_consumptions_other_clicks_unique_description,
        'propSummary': 'average_daily_page_consumptions_by_consumption_type_unique.submetrics.other clicks.value',
        'propDaily': 'page_consumptions_by_consumption_type_unique.submetrics.other clicks.value'
    });

    addFacebookInsightsMetricDescription('CONSUMPTIONS_VIDEO_PLAY_UNIQUE', {
        'dataType': dataType.NUMERIC,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Avg. Daily Unique Video Play Consumptions',
        'abbreviatedName': 'Avg. Daily Unique Video Play Consumptions',
        description: strings.facebook_insights_consumptions_video_play_unique_description,
        'propSummary': 'average_daily_page_consumptions_by_consumption_type_unique.submetrics.video play.value',
        'propDaily': 'page_consumptions_by_consumption_type_unique.submetrics.video play.value'
    });

    addFacebookInsightsMetricDescription('CONSUMPTIONS_LINK_CLICKS_UNIQUE', {
        'dataType': dataType.NUMERIC,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Avg. Daily Unique Link Click Consumptions',
        'abbreviatedName': 'Avg. Daily Unique Link Consumptions',
        description: strings.facebook_insights_consumptions_link_clicks_unique_description,
        'propSummary': 'average_daily_page_consumptions_by_consumption_type_unique.submetrics.link clicks.value',
        'propDaily': 'page_consumptions_by_consumption_type_unique.submetrics.link clicks.value'
    });

    addFacebookInsightsMetricDescription('PAGE_ENGAGEMENT_RATE', {
        'dataType': dataType.ABSOLUTE_PERCENT,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Page Consumption Rate',
        'abbreviatedName': 'Consumption Rate',
        description: strings.facebook_insights_page_engagement_rate_description,
        'propSummary': 'page_engagement_rate',
        'propDaily': 'page_engagement_rate',
        property: 'engagement_rate',
        valueFormat: formatter.absolutePercent
    });

    addFacebookInsightsMetricDescription('PAGE_FANS', {
        'dataType': dataType.INTEGER,
        'category': category.REACH,
        'metricType': metricType.TOTAL,
        'name': 'Facebook Page Fans',
        'abbreviatedName': 'Page Fans',
        description: strings.facebook_insights_page_fans_description,
        'propSummary': 'page_fans',
        'propDaily': 'page_fans'
    });

    addFacebookInsightsMetricDescription('PAGE_FAN_ADDS', {
        'dataType': dataType.INTEGER,
        'category': category.REACH,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Page Fan Adds',
        'abbreviatedName': 'Page Fan Adds',
        description: strings.facebook_insights_page_fan_adds_description,
        'propSummary': 'page_fan_adds',
        'propDaily': 'page_fan_adds'
    });

    addFacebookInsightsMetricDescription('PAGE_FAN_ADDS_UNIQUE', {
        'dataType': dataType.INTEGER,
        'category': category.REACH,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Unique Page Fan Adds',
        'abbreviatedName': 'Unique Page Fan Adds',
        description: strings.facebook_insights_page_fan_adds_unique_description,
        'propSummary': 'page_fan_adds_unique',
        'propDaily': 'page_fan_adds_unique'
    });

    addFacebookInsightsMetricDescription('PAGE_FAN_ADDS_UNPAID', {
        'dataType': dataType.INTEGER,
        'category': category.REACH,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Organic Page Fan Adds',
        'abbreviatedName': 'Organic Page Fan Adds',
        description: strings.facebook_insights_page_fan_adds_unpaid_description,
        'propSummary': 'page_fan_adds_by_paid_non_paid_unique.submetrics.unpaid.value',
        'propDaily': 'page_fan_adds_by_paid_non_paid_unique.submetrics.unpaid.value'
    });

    addFacebookInsightsMetricDescription('PAGE_FAN_ADDS_PAID', {
        'dataType': dataType.INTEGER,
        'category': category.REACH,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Paid Page Fan Adds',
        'abbreviatedName': 'Paid Page Fan Adds',
        description: strings.facebook_insights_page_fan_adds_paid_description,
        'propSummary': 'page_fan_adds_by_paid_non_paid_unique.submetrics.paid.value',
        'propDaily': 'page_fan_adds_by_paid_non_paid_unique.submetrics.paid.value'
    });

    function genderAgeNames(gender, age) {
        return {
            descriptor: (gender === 'F' ? 'Female' : (gender === 'M' ? 'Male' : 'Unspecified')),
            title: (gender === 'F' ? 'women' : (gender === 'M' ? 'men' : 'gender-unspecified persons')),
            ageName: (age === '65+' ? '65_PLUS' : age.replace('-', '_'))
        };
    }

    function addFacebookInsightsAgeGenderMetric(gender, age) {
        const names = genderAgeNames(gender, age);

        addFacebookInsightsMetricDescription(['PAGE_FAN_GENDER_AGE_', gender, names.ageName].join(''), {
            dataType: dataType.INTEGER,
            category: category.REACH,
            metricType: metricType.TOTAL,
            className: names.descriptor.toLowerCase(),
            name: ['Facebook', 'Page Fans, ', names.descriptor, age].join(' '),
            abbreviatedName: ['Page Fans, ', names.descriptor, age].join(' '),
            description: [
                'The number of',
                names.title,
                'aged',
                age,
                'that have become fans of this company on Facebook.'
            ].join(' '),
            propSummary: [
                'page_fans_gender_age.submetrics',
                gender,
                'submetrics',
                age,
                'value'
            ].join('.'),
            propDaily: [
                'page_fans_gender_age.submetrics',
                gender,
                'submetrics',
                age,
                'value'
            ].join('.')
        });
    }

    addFacebookInsightsAgeGenderMetric('F', '13-17');
    addFacebookInsightsAgeGenderMetric('F', '18-24');
    addFacebookInsightsAgeGenderMetric('F', '25-34');
    addFacebookInsightsAgeGenderMetric('F', '35-44');
    addFacebookInsightsAgeGenderMetric('F', '45-54');
    addFacebookInsightsAgeGenderMetric('F', '55-64');
    addFacebookInsightsAgeGenderMetric('F', '65+');

    addFacebookInsightsAgeGenderMetric('M', '13-17');
    addFacebookInsightsAgeGenderMetric('M', '18-24');
    addFacebookInsightsAgeGenderMetric('M', '25-34');
    addFacebookInsightsAgeGenderMetric('M', '35-44');
    addFacebookInsightsAgeGenderMetric('M', '45-54');
    addFacebookInsightsAgeGenderMetric('M', '55-64');
    addFacebookInsightsAgeGenderMetric('M', '65+');

    addFacebookInsightsAgeGenderMetric('U', '13-17');
    addFacebookInsightsAgeGenderMetric('U', '18-24');
    addFacebookInsightsAgeGenderMetric('U', '25-34');
    addFacebookInsightsAgeGenderMetric('U', '35-44');
    addFacebookInsightsAgeGenderMetric('U', '45-54');
    addFacebookInsightsAgeGenderMetric('U', '55-64');
    addFacebookInsightsAgeGenderMetric('U', '65+');

    function addFacebookInsightsImpressionsAgeGenderMetric(gender, age) {
        const names = genderAgeNames(gender, age);

        addFacebookInsightsMetricDescription(['IMPRESSIONS_GENDER_AGE_', gender, names.ageName].join(''), {
            dataType: dataType.NUMERIC,
            category: category.REACH,
            metricType: metricType.VOLUME,
            className: names.descriptor.toLowerCase(),
            name: ['Facebook', 'Avg. Daily Reach (Unique), ', names.descriptor, age].join(' '),
            abbreviatedName: ['Avg. Daily Reach (Unique), ', names.descriptor, age].join(' '),
            description: [
                'The average daily unique number of',
                names.title,
                'aged',
                age,
                'that your page reached on Facebook during the selected time period.'
            ].join(' '),
            propSummary: [
                'average_daily_page_impressions_by_age_gender_unique.submetrics',
                gender,
                'submetrics',
                age,
                'value'
            ].join('.'),
            propDaily: [
                'page_impressions_by_age_gender_unique.submetrics',
                gender,
                'submetrics',
                age,
                'value'
            ].join('.')
        });
    }

    addFacebookInsightsImpressionsAgeGenderMetric('F', '13-17');
    addFacebookInsightsImpressionsAgeGenderMetric('F', '18-24');
    addFacebookInsightsImpressionsAgeGenderMetric('F', '25-34');
    addFacebookInsightsImpressionsAgeGenderMetric('F', '35-44');
    addFacebookInsightsImpressionsAgeGenderMetric('F', '45-54');
    addFacebookInsightsImpressionsAgeGenderMetric('F', '55-64');
    addFacebookInsightsImpressionsAgeGenderMetric('F', '65+');

    addFacebookInsightsImpressionsAgeGenderMetric('M', '13-17');
    addFacebookInsightsImpressionsAgeGenderMetric('M', '18-24');
    addFacebookInsightsImpressionsAgeGenderMetric('M', '25-34');
    addFacebookInsightsImpressionsAgeGenderMetric('M', '35-44');
    addFacebookInsightsImpressionsAgeGenderMetric('M', '45-54');
    addFacebookInsightsImpressionsAgeGenderMetric('M', '55-64');
    addFacebookInsightsImpressionsAgeGenderMetric('M', '65+');

    addFacebookInsightsImpressionsAgeGenderMetric('U', '13-17');
    addFacebookInsightsImpressionsAgeGenderMetric('U', '18-24');
    addFacebookInsightsImpressionsAgeGenderMetric('U', '25-34');
    addFacebookInsightsImpressionsAgeGenderMetric('U', '35-44');
    addFacebookInsightsImpressionsAgeGenderMetric('U', '45-54');
    addFacebookInsightsImpressionsAgeGenderMetric('U', '55-64');
    addFacebookInsightsImpressionsAgeGenderMetric('U', '65+');

    addFacebookInsightsMetricDescription('PAGE_VIEWS_TOTAL', {
        dataType: dataType.INTEGER,
        category: category.REACH,
        metricType: metricType.VOLUME,
        name: 'Facebook Page Views',
        abbreviatedName: 'Page Views',
        description: strings.facebook_insights_page_views_total_description,
        propSummary: 'page_views_total',
        propDaily: 'page_views_total'
    });

    addFacebookInsightsMetricDescription('PAGE_CALL_PHONE_CLICKS_LOGGED_IN_UNIQUE', {
        dataType: dataType.INTEGER,
        category: category.REACH,
        metricType: metricType.VOLUME,
        name: 'Facebook Phone Call Clicks',
        abbreviatedName: 'Phone Call Clicks',
        description: strings.facebook_insights_page_call_phone_clicks_logged_in_unique_description,
        propSummary: 'page_call_phone_clicks_logged_in_unique',
        propDaily: 'page_call_phone_clicks_logged_in_unique'
    });

    addFacebookInsightsMetricDescription('PAGE_GET_DIRECTIONS_CLICKS_LOGGED_IN_UNIQUE', {
        dataType: dataType.INTEGER,
        category: category.REACH,
        metricType: metricType.VOLUME,
        name: 'Facebook Direction Clicks',
        abbreviatedName: 'Direction Clicks',
        description: strings.facebook_insights_page_get_directions_clicks_logged_in_unique_description,
        propSummary: 'page_get_directions_clicks_logged_in_unique',
        propDaily: 'page_get_directions_clicks_logged_in_unique'
    });

    addFacebookInsightsMetricDescription('PAGE_WEBSITE_CLICKS_LOGGED_IN_UNIQUE', {
        dataType: dataType.INTEGER,
        category: category.REACH,
        metricType: metricType.VOLUME,
        name: 'Facebook Website Clicks',
        abbreviatedName: 'Website Clicks',
        description: strings.facebook_insights_page_website_clicks_logged_in_unique_description,
        propSummary: 'page_website_clicks_logged_in_unique',
        propDaily: 'page_website_clicks_logged_in_unique'
    });

    // Facebook Insights POST Metric
    addFacebookInsightsMetricDescription('POST_REACH', {
        'dataType': dataType.INTEGER,
        'category': category.REACH,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Post Total Reach',
        'abbreviatedName': 'Total Reach',
        description: '',
        'propSummary': 'post_total_reach',
        'propDaily': 'post_total_reach',
        dontShowInUi: true
    });

    addFacebookInsightsMetricDescription('PAGE_FAN_ADDS', {
        'dataType': dataType.INTEGER,
        'category': category.REACH,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Page Fan Adds',
        'abbreviatedName': 'Page Fan Adds',
        description: strings.facebook_insights_page_fan_adds_description,
        'propSummary': 'page_fan_adds',
        'propDaily': 'page_fan_adds'
    });

    addFacebookInsightsMetricDescription('PAGE_FAN_REMOVES', {
        'dataType': dataType.INTEGER,
        'category': category.REACH,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Page Fan Removes',
        'abbreviatedName': 'Page Fan Removes',
        description: strings.facebook_insights_page_fan_removes_description,
        'propSummary': 'page_fan_removes',
        'propDaily': 'page_fan_removes'
    });

    addFacebookInsightsMetricDescription('PAGE_FAN_REMOVES_UNIQUE', {
        'dataType': dataType.INTEGER,
        'category': category.REACH,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Unique Page Fan Removes',
        'abbreviatedName': 'Unique Page Fan Removes',
        description: strings.facebook_insights_page_fan_removes_unique_description,
        'propSummary': 'page_fan_removes_unique',
        'propDaily': 'page_fan_removes_unique'
    });

    addFacebookInsightsMetricDescription('PAGE_CTA_CLICKS_LOGGED_IN_UNIQUE', {
        'dataType': dataType.INTEGER,
        'category': category.REACH,
        'metricType': metricType.VOLUME,
        'name': 'Facebook CTA Button Clicks',
        'abbreviatedName': 'CTA Button Clicks',
        description: strings.facebook_insights_page_cta_clicks_logged_in_unique_description,
        'propSummary': 'page_cta_clicks_logged_in_unique',
        'propDaily': 'page_cta_clicks_logged_in_unique'
    });

    addFacebookInsightsMetricDescription('PAGE_TOTAL_ACTIONS', {
        'dataType': dataType.INTEGER,
        'category': category.REACH,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Page CTA Clicks',
        'abbreviatedName': 'Page CTA Clicks',
        description: strings.facebook_insights_page_total_actions_description,
        'propSummary': 'page_total_actions',
        'propDaily': 'average_daily_page_total_actions'
    });

    addFacebookInsightsMetricDescription('IMPRESSIONS_VIRAL_UNIQUE', {
        'dataType': dataType.NUMERIC,
        'category': category.REACH,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Avg. Daily Viral Page Reach (Unique Impressions)',
        'abbreviatedName': 'Avg. Daily Viral Page Reach (Unique Impressions)',
        description: strings.facebook_insights_impressions_viral_unique_description,
        'propSummary': 'average_daily_page_impressions_viral_unique',
        'propDaily': 'page_impressions_viral_unique'
    });

    addFacebookInsightsMetricDescription('IMPRESSIONS_NONVIRAL', {
        'dataType': dataType.INTEGER,
        'category': category.REACH,
        'metricType': metricType.VOLUME,
        'name': 'Facebook Non-Viral Page Impressions',
        'abbreviatedName': 'Non-Viral Page Impressions',
        description: strings.facebook_insights_impressions_nonviral_description,
        'propSummary': 'page_impressions_nonviral',
        'propDaily': 'page_impressions_nonviral'
    });

    // linkedin
    addLinkedInMetricDescription('FOLLOWERS', {
        dataType: dataType.INTEGER,
        category: category.REACH,
        metricType: metricType.TOTAL,
        name: 'LinkedIn Total Followers',
        abbreviatedName: 'Followers',
        description: strings.linked_in_followers_description,
        propSummary: 'followers',
        propDaily: 'followers'
    });

    addLinkedInMetricDescription('FOLLOWER_ADDS_ORGANIC', {
        dataType: dataType.INTEGER,
        category: category.REACH,
        metricType: metricType.VOLUME,
        name: 'LinkedIn Organic Follower Adds',
        abbreviatedName: 'Organic Follower Adds',
        description: strings.linked_in_presence_reach_adds_organic_description,
        propSummary: 'organic_follower_adds',
        propDaily: 'organic_follower_adds'
    });

    addLinkedInMetricDescription('FOLLOWER_ADDS_PAID', {
        dataType: dataType.INTEGER,
        category: category.REACH,
        metricType: metricType.VOLUME,
        name: 'LinkedIn Paid Follower Adds',
        abbreviatedName: 'Paid Follower Adds',
        description: strings.linked_in_presence_reach_adds_paid_description,
        propSummary: 'paid_follower_adds',
        propDaily: 'paid_follower_adds'
    });

    addLinkedInMetricDescription('VISITORS_UNIQUE', {
        dataType: dataType.INTEGER,
        category: category.REACH,
        metricType: metricType.VOLUME,
        name: 'LinkedIn Unique Update Visitors',
        abbreviatedName: 'Update Reach',
        description: strings.linked_in_unique_post_visitors_description,
        propSummary: 'unique_visitors',
        propDaily: 'unique_visitors'
    });

    addLinkedInMetricDescription('AVERAGE_VISITORS_UNIQUE', {
        dataType: dataType.NUMERIC,
        category: category.REACH,
        metricType: metricType.VOLUME,
        name: 'LinkedIn Unique Update Visitors',
        abbreviatedName: 'Presence Update Reach / Day',
        description: strings.linked_in_visitors_unique_by_day_description,
        propSummary: 'average_unique_visitors',
        propDaily: 'unique_visitors'
    });

    (function () {

        const jobFunctionMap = LinkedInJobFunctionMap;

        _.each(jobFunctionMap, function (config) {

            const description = config.description;
            const code = (config.key || config.code);
            const name = description.replace(/&/g, 'and').replace(/\s/g, '_')
                .toUpperCase();

            addLinkedInMetricDescription(`FOLLOWERS_JOB_FUNCTION_${name}`, {
                dataType: dataType.INTEGER,
                category: category.REACH,
                metricType: metricType.TOTAL,
                name: `LinkedIn Job Function ${description} Followers`,
                abbreviatedName: `Job Function ${description} Followers`,
                description: `The number of followers with ${description} job function this company has on LinkedIn.`,
                propSummary: `followers_by_job_function_${code}`,
                propDaily: `followers_by_job_function_${code}`
            });
        });

    }());

    addLinkedInMetricDescription('UPDATE_CLICKS', {
        dataType: dataType.INTEGER,
        category: category.ENGAGEMENT,
        metricType: metricType.VOLUME,
        name: 'LinkedIn Update Clicks',
        abbreviatedName: 'Update Clicks',
        description: strings.linked_in_update_clicks_description,
        propSummary: 'page_update_clicks',
        propDaily: 'page_update_clicks'
    });

    addLinkedInMetricDescription('UPDATE_LIKES', {
        dataType: dataType.INTEGER,
        category: category.ENGAGEMENT,
        metricType: metricType.VOLUME,
        name: 'LinkedIn Update Likes',
        abbreviatedName: 'Update Likes',
        description: strings.linked_in_update_likes_description,
        propSummary: 'page_update_likes',
        propDaily: 'page_update_likes'
    });

    addLinkedInMetricDescription('UPDATE_COMMENTS', {
        dataType: dataType.INTEGER,
        category: category.ENGAGEMENT,
        metricType: metricType.VOLUME,
        name: 'LinkedIn Update Comments',
        abbreviatedName: 'Update Comments',
        description: strings.linked_in_update_comments_description,
        propSummary: 'page_update_comments',
        propDaily: 'page_update_comments'
    });

    addLinkedInMetricDescription('UPDATE_SHARES', {
        dataType: dataType.INTEGER,
        category: category.ENGAGEMENT,
        metricType: metricType.VOLUME,
        name: 'LinkedIn Update Shares',
        abbreviatedName: 'Update Shares',
        description: strings.linked_in_update_shares_description,
        propSummary: 'page_update_shares',
        propDaily: 'page_update_shares'
    });

    addLinkedInMetricDescription('UPDATE_IMPRESSIONS', {
        dataType: dataType.INTEGER,
        category: category.ENGAGEMENT,
        metricType: metricType.VOLUME,
        name: 'LinkedIn Presence Update Impressions',
        abbreviatedName: 'Presence Update Impressions',
        description: strings.linked_in_update_impressions_description,
        propSummary: 'page_update_impressions',
        propDaily: 'page_update_impressions'
    });

    addLinkedInMetricDescription('AVERAGE_UPDATE_IMPRESSIONS', {
        dataType: dataType.NUMERIC,
        category: category.REACH,
        metricType: metricType.VOLUME,
        name: 'LinkedIn Presence Update Impressions / Day',
        abbreviatedName: 'Presence Update Impressions / Day',
        description: strings.linked_in_post_impressions_per_day_description,
        propSummary: 'page_update_impressions_per_day',
        propDaily: 'page_update_impressions'
    });

    addLinkedInMetricDescription('ENGAGEMENT', {
        dataType: dataType.INTEGER,
        category: category.ENGAGEMENT,
        metricType: metricType.VOLUME,
        name: 'LinkedIn Presence Update Engagement Total',
        abbreviatedName: 'Presence Update Engagement Total',
        description: strings.linked_in_engagement_total_description,
        submetrics: [
            'LINKED_IN_UPDATE_CLICKS',
            'LINKED_IN_UPDATE_LIKES',
            'LINKED_IN_UPDATE_COMMENTS',
            'LINKED_IN_UPDATE_SHARES'
        ],
        propSummary: 'page_engagement_total',
        propDaily: 'page_engagement_total'
    });

    addLinkedInMetricDescription('ENGAGEMENT_RATE', {
        'dataType': dataType.ABSOLUTE_PERCENT,
        'category': category.ENGAGEMENT,
        'metricType': metricType.VOLUME,
        'name': 'LinkedIn Engagement Rate',
        'abbreviatedName': 'Engagement Rate',
        description: strings.linked_in_engagement_rate_description,
        'propSummary': 'page_engagement_rate',
        'propDaily': 'page_engagement_rate',
        property: 'page_engagement_rate'
    });

    addLinkedInMetricDescription('OVERVIEW_PAGE_VIEWS', {
        dataType: dataType.INTEGER,
        category: category.REACH,
        metricType: metricType.VOLUME,
        name: 'LinkedIn Page Views',
        abbreviatedName: 'Page Views',
        description: 'The total number of views on this LinkedIn page during the selected time period.',
        propSummary: 'overview_page_views',
        propDaily: 'overview_page_views'
    });

    addLinkedInMetricDescription('OVERVIEW_PAGE_UNIQUE_VIEWS', {
        dataType: dataType.INTEGER,
        category: category.REACH,
        metricType: metricType.VOLUME,
        name: 'LinkedIn Unique Page Views',
        abbreviatedName: 'Unique Page Views',
        description: 'The average number of times this LinkedIn page was viewed each day.',
        propSummary: 'overview_page_unique_views',
        propDaily: 'overview_page_unique_views'
    });

    addLinkedInMetricDescription('AVERAGE_OVERVIEW_PAGE_UNIQUE_VIEWS', {
        dataType: dataType.NUMERIC,
        category: category.REACH,
        metricType: metricType.VOLUME,
        name: 'LinkedIn Unique Page Views Per Day',
        abbreviatedName: 'Unique Page Views / Day',
        description: 'The average number of times this LinkedIn page was viewed each day.',
        propSummary: 'average_overview_page_unique_views',
        propDaily: 'overview_page_unique_views'
    });

    addInstagramInsightsMetricDescription('FOLLOWERS_COUNT', {
        dataType: dataType.INTEGER,
        category: category.REACH,
        metricType: metricType.VOLUME,
        description: strings.instagram_insights_followers_count_profile_description,
        name: 'Followers',
        propSummary: 'followers_count',
        propDaily: 'followers_count'
    });

    addInstagramInsightsMetricDescription('NEW_FOLLOWER_COUNT', {
        dataType: dataType.INTEGER,
        category: category.REACH,
        metricType: metricType.VOLUME,
        description: strings.instagram_insights_new_follower_count_profile_description,
        name: 'Follower Adds',
        propSummary: 'new_follower_count',
        propDaily: 'new_follower_count'
    });

    // NOTE deprecated, but leaving here to not throw off the incrementing id assignments
    addInstagramInsightsMetricDescription('FOLLOWER_LOSS', {
        dataType: dataType.INTEGER,
        category: category.REACH,
        metricType: metricType.VOLUME,
        description: strings.instagram_insights_follower_loss_profile_description,
        name: 'Follower Removes [DEPRECATED]',
        propSummary: 'follower_loss',
        propDaily: 'follower_loss'
    });

    // NOTE deprecated, but leaving here to not throw off the incrementing id assignments
    addInstagramInsightsMetricDescription('NET_FOLLOWER_CHANGE', {
        dataType: dataType.INTEGER,
        category: category.REACH,
        metricType: metricType.VOLUME,
        description: strings.instagram_insights_followers_count_change_profile_description,
        name: 'Net Follower Change [DEPRECATED]',
        propSummary: 'net_follower_change',
        propDaily: 'net_follower_change'
    });

    addInstagramInsightsMetricDescription('POSTS', {
        dataType: dataType.INTEGER,
        category: category.ACTIVITY,
        metricType: metricType.VOLUME,
        description: strings.instagram_insights_daily_posts_description,
        name: 'Posts',
        propSummary: 'daily_posts',
        propDaily: 'daily_posts'
    });

    addInstagramInsightsMetricDescription('DAYS_WITH_STORY', {
        dataType: dataType.INTEGER,
        category: category.ACTIVITY,
        description: strings.instagram_insights_days_with_story_description,
        name: 'Stories',
        propSummary: 'days_with_story',
        propDaily: 'num_stories'
    });

    addInstagramInsightsMetricDescription('PROFILE_VIEWS', {
        dataType: dataType.NUMERIC,
        category: category.REACH,
        metricType: metricType.VOLUME,
        description: strings.instagram_insights_profile_views_profile_description,
        name: 'Profile Views',
        propSummary: 'profile_views',
        propDaily: 'profile_views'
    });

    addInstagramInsightsMetricDescription('PROFILE_ENGAGEMENTS', {
        dataType: dataType.INTEGER,
        category: category.ENGAGEMENT,
        metricType: metricType.VOLUME,
        description: strings.instagram_insights_profile_engagements_description,
        name: 'Profile Engagements',
        propSummary: 'profile_engagements',
        propDaily: 'profile_engagements'
    });

    addInstagramInsightsMetricDescription('EMAIL_CLICKS', {
        dataType: dataType.INTEGER,
        category: category.ENGAGEMENT,
        metricType: metricType.VOLUME,
        name: 'Email Clicks',
        propSummary: 'email_contacts',
        propDaily: 'email_contacts'
    });

    addInstagramInsightsMetricDescription('WEBSITE_CLICKS', {
        dataType: dataType.INTEGER,
        category: category.ENGAGEMENT,
        metricType: metricType.VOLUME,
        name: 'Website Clicks',
        propSummary: 'website_clicks',
        propDaily: 'website_clicks'
    });

    addInstagramInsightsMetricDescription('DIRECTION_CLICKS', {
        dataType: dataType.INTEGER,
        category: category.ENGAGEMENT,
        metricType: metricType.VOLUME,
        name: 'Direction Clicks',
        propSummary: 'get_directions_clicks',
        propDaily: 'get_directions_clicks'
    });

    addInstagramInsightsMetricDescription('PHONE_CALL_CLICKS', {
        dataType: dataType.INTEGER,
        category: category.ENGAGEMENT,
        metricType: metricType.VOLUME,
        name: 'Phone Call Clicks',
        propSummary: 'phone_call_clicks',
        propDaily: 'phone_call_clicks'
    });

    addInstagramInsightsMetricDescription('TEXT_MESSAGE_CLICKS', {
        dataType: dataType.INTEGER,
        category: category.ENGAGEMENT,
        metricType: metricType.VOLUME,
        name: 'Text Message Clicks',
        propSummary: 'text_message_clicks',
        propDaily: 'text_message_clicks'
    });

    addInstagramInsightsMetricDescription('REACH_PER_DAY', {
        dataType: dataType.NUMERIC,
        category: category.ENGAGEMENT,
        metricType: metricType.VOLUME,
        description: strings.instagram_insights_presence_reach_per_day_metric_description,
        name: 'Presence Reach',
        propSummary: 'page_reach_per_day',
        propDaily: 'page_reach'
    });

    addInstagramInsightsMetricDescription('IMPRESSIONS', {
        dataType: dataType.INTEGER,
        category: category.ENGAGEMENT,
        metricType: metricType.VOLUME,
        description: strings.instagram_insights_presence_impressions_metric_description,
        name: 'Presence Impressions',
        propSummary: 'page_impressions',
        propDaily: 'page_impressions'
    });

    addInstagramInsightsMetricDescription('IMPRESSIONS_PER_DAY', {
        dataType: dataType.NUMERIC,
        category: category.ENGAGEMENT,
        metricType: metricType.VOLUME,
        description: strings.instagram_insights_presence_impressions_per_day_metric_description,
        name: 'Presence Impressions',
        propSummary: 'page_impressions_per_day',
        propDaily: 'page_impressions'
    });

    function addInstagramInsightsAgeGenderMetric(gender, age) {
        const names = genderAgeNames(gender, age);

        addInstagramInsightsMetricDescription(['FOLLOWERS_GENDER_AGE_', gender, names.ageName].join(''), {
            dataType: dataType.INTEGER,
            category: category.REACH,
            metricType: metricType.TOTAL,
            className: names.descriptor.toLowerCase(),
            name: ['Instagram', 'Followers, ', names.descriptor, age].join(' '),
            abbreviatedName: ['Followers, ', names.descriptor, age].join(' '),
            description: [
                'The number of',
                names.title,
                'aged',
                age,
                'that follow this profile on Instagram.'
            ].join(' '),
            propSummary: [
                'audience_gender_age.submetrics',
                gender,
                'submetrics',
                age,
                'value'
            ].join('.'),
            propDaily: [
                'audience_gender_age.submetrics',
                gender,
                'submetrics',
                age,
                'value'
            ].join('.')
        });
    }

    addInstagramInsightsAgeGenderMetric('F', '13-17');
    addInstagramInsightsAgeGenderMetric('F', '18-24');
    addInstagramInsightsAgeGenderMetric('F', '25-34');
    addInstagramInsightsAgeGenderMetric('F', '35-44');
    addInstagramInsightsAgeGenderMetric('F', '45-54');
    addInstagramInsightsAgeGenderMetric('F', '55-64');
    addInstagramInsightsAgeGenderMetric('F', '65+');

    addInstagramInsightsAgeGenderMetric('M', '13-17');
    addInstagramInsightsAgeGenderMetric('M', '18-24');
    addInstagramInsightsAgeGenderMetric('M', '25-34');
    addInstagramInsightsAgeGenderMetric('M', '35-44');
    addInstagramInsightsAgeGenderMetric('M', '45-54');
    addInstagramInsightsAgeGenderMetric('M', '55-64');
    addInstagramInsightsAgeGenderMetric('M', '65+');

    addInstagramInsightsAgeGenderMetric('U', '13-17');
    addInstagramInsightsAgeGenderMetric('U', '18-24');
    addInstagramInsightsAgeGenderMetric('U', '25-34');
    addInstagramInsightsAgeGenderMetric('U', '35-44');
    addInstagramInsightsAgeGenderMetric('U', '45-54');
    addInstagramInsightsAgeGenderMetric('U', '55-64');
    addInstagramInsightsAgeGenderMetric('U', '65+');

    pushMetric(metricsModels.InstagramStoryDayInsights, {
        id: INSIGHTS_METRICS_SEED++,
        semanticId: 'INSTAGRAM_STORY_DAYS',
        source: source.INSTAGRAM_INSIGHTS,
        name: 'Instagram Story Days',
        dontShowInUi: true,
        childProperties: [
            'num_stories',
            'max_reach',
            'stories_retention_rate'
        ]
    });

    pushMetric(metricsModels.InstagramStoryInsights, {
        id: INSIGHTS_METRICS_SEED++,
        semanticId: 'INSTAGRAM_STORIES',
        source: source.INSTAGRAM_INSIGHTS,
        name: 'Instagram Stories',
        dontShowInUi: true,
        childProperties: [
            {
                property: 'reach_rate',
                submetrics: [
                    'reach',
                    'impressions',
                    'presence_reach'
                ]
            },
            'completion_rate',
            {
                property: 'exit_rate',
                submetrics: [
                    'exits'
                ]
            },
            'profile_visits',
            {
                property: 'profile_activity_total',
                submetrics: [
                    'profile_activity_bio_link_clicked',
                    'profile_activity_not_bio_link_clicked'
                ]
            },
            'follows',
            'swipes_forward',
            'taps_forward',
            'taps_back',
            'full_view_rate',
            'shares',
            'replies'
        ]
    });

    pushMetric(metricsModels.PostInsights, {
        id: INSIGHTS_METRICS_SEED++,
        semanticId: 'INSIGHTS_POSTS_SEARCH',
        source: source.INSTAGRAM_INSIGHTS,
        name: 'Instagram Posts',
        dontShowInUi: true,
        childProperties: [
            {
                property: 'reach_rate',
                submetrics: [
                    'reach',
                    'impressions',
                    'presence_reach'
                ]
            },
            {
                property: 'engagement_total',
                submetrics: [
                    'likes',
                    'comments',
                    'saves'
                ]
            },
            'engagement_rate'
        ]
    });

    // NOTE these mappings exist to fix favorites made with previous values
    const metricMappings = {};
    metricMappings[16003] = metricDescriptions.CROSS_CHANNEL_AUDIENCE.id;
    metricMappings[16005] = metricDescriptions.CROSS_CHANNEL_ACTIVITY.id;
    metricMappings[16007] = metricDescriptions.CROSS_CHANNEL_ENGAGEMENT.id;
    metricMappings[16009] = metricDescriptions.CROSS_CHANNEL_APPLAUSE.id;
    metricMappings[16011] = metricDescriptions.CROSS_CHANNEL_CONVERSATION.id;
    metricMappings[16013] = metricDescriptions.CROSS_CHANNEL_AMPLIFICATION.id;

    function pushMetric(type, attrs) {
        const metric = _.create(type, attrs);
        metricDescriptions[metric.semanticId] = metric;
    }

    pushMetric(metricsModels.SocialPosts, {
        id: SOCIAL_POSTS_SEED++,
        semanticId: 'SOCIAL_POSTS',
        source: source.CROSS_CHANNEL,
        category: category.REACH,
        metricType: metricType.TOTAL,
        name: 'Cross Channel Social Posts',
        description: '',
        childProperties: [
            'count',
            {
                property: 'count / period'
            },
            'avg_engagement_rate_per_post',
            'with_hashtags'
        ],
        dontShowInUi: true
    });

    const facebookChannelReactionsProperties = {
        property: 'reactions',
        description: strings.facebook_posts_reactions_description,
        submetrics: [
            {
                property: 'likes',
                description: strings.facebook_posts_likes_description
            },
            {
                property: 'loves',
                description: strings.facebook_posts_loves_description
            },
            {
                property: 'hahas',
                description: strings.facebook_posts_hahas_description
            },
            {
                property: 'wows',
                description: strings.facebook_posts_wows_description
            },
            {
                property: 'sads',
                description: strings.facebook_posts_sads_description
            },
            {
                property: 'angrys',
                description: strings.facebook_posts_angrys_description
            }
        ]
    };

    const estimatedImpressionsProperty = {
        property: 'estimated_impressions',
        selectable: function () {
            return RivalIQ.state.account.get('plan').has_estimated_impressions;
        }
    };
    const engRateByEstimatedImpressionsProperty = {
        property: 'engagement_rate_by_estimated_impression',
        selectable: function () {
            return RivalIQ.state.account.get('plan').has_estimated_impressions;
        }
    };


    pushMetric(metricsModels.SocialPost, {
        id: SOCIAL_POSTS_SEED++,
        semanticId: 'SOCIAL_POST',
        source: source.CROSS_CHANNEL,
        name: 'Social Post',
        description: '',
        childProperties: [
            'presence_reach',
            'engagement_rate',
            'engagement_rate_by_presence_reach_lift',
            {
                property: 'company_id',
                selectable: false
            },
            {
                property: 'published_at',
                selectable: false
            },
            {
                property: 'captured_at',
                selectable: false
            },
            {
                property: 'message',
                selectable: false
            },
            {
                property: 'postLink',
                selectable: false
            },
            {
                property: 'link',
                selectable: false
            },
            {
                property: 'linkTitle',
                selectable: false
            },
            {
                property: 'linkDescription',
                selectable: false
            },
            {
                property: 'image',
                selectable: false
            },
            'type',
            'presence_handle',
            {
                property: 'views',
                type: 'video',
                excludedChannels: [
                    'twitter',
                    'facebook',
                    'instagram'
                ]
            },
            {
                property: 'canonicalUrl',
                selectable: false
            },
            {
                property: 'primaryDomain',
                selectable: false
            }
        ],
        channelProperties: {
            cross_channel: [
                {
                    property: 'source',
                    selectable: false
                },
                estimatedImpressionsProperty,
                engRateByEstimatedImpressionsProperty
            ],
            facebook: [
                facebookChannelReactionsProperties,
                {
                    property: 'promoted_likelyhood',
                    selectable: function () {
                        return RivalIQ.state.account.get('plan').has_likely_promoted;
                    }
                },
                {
                    property: 'views',
                    type: 'video',
                    index: 1
                },
                {
                    property: 'post_views',
                    type: 'video',
                    index: 1
                },
                estimatedImpressionsProperty,
                engRateByEstimatedImpressionsProperty
            ],
            instagram: [
                estimatedImpressionsProperty,
                engRateByEstimatedImpressionsProperty
            ],
            twitter: [
                'tweetType',
                {
                    property: 'video_views',
                    type: 'video',
                    index: 1
                },
                'impressions'
            ],
            tiktok: [
                {
                    property: 'engagement_rate_by_view',
                    index: 3
                }
            ],
            youtube: [
                {
                    property: 'engagement_rate_by_view',
                    index: 4
                }
            ]
        },
        dontShowInUi: true
    });

    pushMetric(metricsModels.Hashtags, {
        id: SOCIAL_POSTS_SEED++,
        semanticId: 'SOCIAL_POSTS_HASHTAGS',
        source: source.CROSS_CHANNEL,
        category: category.REACH,
        metricType: metricType.TOTAL,
        name: 'Cross Channel Hashtags',
        description: '',
        childProperties: [
            'count',
            'companies_using',
            'avg_engagement_rate_per_post',
            'engagement_total_per_post',
            'potential_reach',
            'engagement_rate_by_presence_reach_lift',
            'views'
        ],
        channelProperties: {
            cross_channel: [
                estimatedImpressionsProperty,
                engRateByEstimatedImpressionsProperty
            ],
            facebook: [
                facebookChannelReactionsProperties,
                {
                    property: 'promoted_likelyhood',
                    selectable: function () {
                        return RivalIQ.state.account.get('plan').has_likely_promoted;
                    }
                },
                'views',
                'post_views',
                estimatedImpressionsProperty,
                engRateByEstimatedImpressionsProperty
            ],
            instagram: [
                estimatedImpressionsProperty,
                engRateByEstimatedImpressionsProperty
            ],
            twitter: [
                {
                    property: 'views',
                    index: 1
                },
                estimatedImpressionsProperty,
                engRateByEstimatedImpressionsProperty
            ],
            tiktok: [
                {
                    property: 'views',
                    index: 1
                },
                {
                    property: 'engagement_total_per_view',
                    index: 5
                }
            ],
            youtube: [
                {
                    property: 'engagement_total_per_view',
                    index: 5
                }
            ]
        },
        dontShowInUi: true
    });

    pushMetric(metricsModels.PostedUrls, {
        id: SOCIAL_POSTS_SEED++,
        semanticId: 'SOCIAL_POSTS_POSTED_URLS',
        source: source.CROSS_CHANNEL,
        category: category.REACH,
        metricType: metricType.TOTAL,
        name: 'Cross Channel Primary Domains',
        description: '',
        childProperties: [
            'count',
            'companies_using',
            'shared_url_count_distinct',
            'avg_engagement_rate_per_post',
            'engagement_total_per_post'
        ],
        channelProperties: {
            cross_channel: [
                estimatedImpressionsProperty,
                engRateByEstimatedImpressionsProperty
            ],
            facebook: [
                facebookChannelReactionsProperties,
                {
                    property: 'promoted_likelyhood',
                    selectable: function () {
                        return RivalIQ.state.account.get('plan').has_likely_promoted;
                    }
                },
                'views',
                'post_views',
                estimatedImpressionsProperty,
                engRateByEstimatedImpressionsProperty
            ],
            instagram: [
                estimatedImpressionsProperty,
                engRateByEstimatedImpressionsProperty
            ],
            twitter: [
                {
                    // use views for ES mapping compatibility
                    property: 'views',
                    index: 1
                },
                estimatedImpressionsProperty,
                engRateByEstimatedImpressionsProperty
            ]
        },
        dontShowInUi: true
    });

    pushMetric(metricsModels.PostTagIds, {
        id: SOCIAL_POSTS_SEED++,
        semanticId: 'SOCIAL_POSTS_POST_TAG_IDS',
        source: source.CROSS_CHANNEL,
        category: category.REACH,
        metricType: metricType.TOTAL,
        name: 'Cross Channel Post Tags',
        description: '',
        childProperties: [
            'companies_using',
            'count',
            'engagement_total_per_post',
            'avg_engagement_rate_per_post',
            'other_posts_engagement_rate_by_presence_reach',
            'engagement_rate_by_presence_reach_lift',
            'views'
        ],
        channelProperties: {
            cross_channel: [
                estimatedImpressionsProperty,
                engRateByEstimatedImpressionsProperty
            ],
            facebook: [
                facebookChannelReactionsProperties,
                {
                    property: 'promoted_likelyhood',
                    selectable: function () {
                        return RivalIQ.state.account.get('plan').has_likely_promoted;
                    }
                },
                'views',
                'post_views',
                estimatedImpressionsProperty,
                engRateByEstimatedImpressionsProperty
            ],
            instagram: [
                estimatedImpressionsProperty,
                engRateByEstimatedImpressionsProperty
            ],
            twitter: [
                {
                    // use views for ES mapping compatibility
                    property: 'views',
                    index: 1
                },
                estimatedImpressionsProperty,
                engRateByEstimatedImpressionsProperty
            ],
            tiktok: [
                {
                    property: 'views'
                },
                {
                    property: 'engagement_total_per_view',
                    index: 6
                }
            ],
            youtube: [
                {
                    property: 'engagement_total_per_view',
                    index: 5
                }
            ]
        },
        dontShowInUi: true
    });

    function numericValueSort(valueFunction) {
        return function (order, a, b) {
            let value;

            const aVal = valueFunction(a);
            const bVal = valueFunction(b);

            if (isNaN(aVal)) {
                value = -1;
            } else if (isNaN(bVal)) {
                value = 1;
            } else {
                value = aVal - bVal;
            }

            return order * value;
        };
    }

    function getFacebookInsightsPostPropertyDisplayString(property, defaultValue) {

        const postProperty = `facebook_insights_${property}_description`;
        defaultValue = (defaultValue || 'Description text is coming soon!');
        return _.get(strings, [postProperty], defaultValue);
    }

    function createColumnNameRenderer(template) {

        let compiled = null;
        return function (parent, metric) {
            if (!compiled) {
                compiled = _.template(template);
            }
            return compiled(_.extend({
                parent: parent
            }, metric));
        };
    }

    const reverseHierarchyColumnNameRenderer = createColumnNameRenderer('<%- name %> <%- parent.name %>');
    const paidColumnNameRenderer = createColumnNameRenderer('Paid <%- name %>');
    const organicColumnNameRenderer = createColumnNameRenderer('Organic <%- name %>');
    const viaAdsNameRenderer = createColumnNameRenderer('<%- name %> via Ads');
    const viaInsightsNameRenderer = createColumnNameRenderer('<%- name %> via Insights');


    const facebookInsightsPostDetailMetrics = [
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            semanticId: 'FACEBOOK_INSIGHTS_POST_DETAILS',
            source: source.FACEBOOK_INSIGHTS,
            name: 'Facebook Insights Post',
            abbreviatedName: 'Post',
            description: ''
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            semanticId: 'FACEBOOK_INSIGHTS_BOOSTED_TOTAL_SPEND',
            name: 'Total Spend',
            valueFormat: formatter.falsyDataWrapper(function (value) {
                return formatter.formatAmountAndCurrency(value);
            }),
            sort: numericValueSort(function (post) {
                return Number(RivalIQ.metric.data.rawValue(null, [post.boosted_post_total_spend]));
            }),
            property: 'boosted_post_total_spend',
            description: 'The amount of money spent boosting this post.'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_53',
            semanticId: 'FACEBOOK_INSIGHTS_POST_CONSUMPTIONS_UNIQUE',
            name: 'Consumptions (Unique users)',
            valueFormat: formatter.formats.abbreviated,
            property: 'facebook_insights_data.post_consumptions_unique',
            description: getFacebookInsightsPostPropertyDisplayString('post_consumptions')
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_54',
            semanticId: 'FACEBOOK_INSIGHTS_POST_CONSUMPTIONS_UNIQUE_LINK_CLICKS',
            default: 0,
            name: 'Link Clicks',
            valueFormat: formatter.formats.abbreviated,
            description: 'The unique number of users who clicked a link in your post.',
            property: 'facebook_insights_data.post_consumptions_by_type_unique.link clicks',
            propertyAlias: 'alias.post_consumptions_by_type_unique.link_clicks'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_55',
            semanticId: 'FACEBOOK_INSIGHTS_POST_CONSUMPTIONS_UNIQUE_PHOTO_VIEWS',
            default: 0,
            name: 'Photo Views',
            valueFormat: formatter.formats.abbreviated,
            description: 'The unique number of users who clicked to view a photo in your post.',
            property: 'facebook_insights_data.post_consumptions_by_type_unique.photo view',
            propertyAlias: 'alias.post_consumptions_by_type_unique.photo_view'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_56',
            semanticId: 'FACEBOOK_INSIGHTS_POST_CONSUMPTIONS_UNIQUE_VIDEO_PLAYS',
            default: 0,
            name: 'Video Plays',
            valueFormat: formatter.formats.abbreviated,
            description: 'The unique number of users who clicked to view a video in your post.',
            property: 'facebook_insights_data.post_consumptions_by_type_unique.video play',
            propertyAlias: 'alias.post_consumptions_by_type_unique.video_play'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_57',
            semanticId: 'FACEBOOK_INSIGHTS_POST_CONSUMPTIONS_UNIQUE_OTHER_CLICKS',
            default: 0,
            name: 'Other Clicks',
            valueFormat: formatter.formats.abbreviated,
            description: 'The unique number of users who clicked in your post (outside of to view a photo, video, or link).',
            property: 'facebook_insights_data.post_consumptions_by_type_unique.other clicks',
            propertyAlias: 'alias.post_consumptions_by_type_unique.other_clicks'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_44',
            semanticId: 'FACEBOOK_INSIGHTS_POST_ENGAGEMENT_RATE',
            omit: false,
            name: 'Facebook Engagement Rate',
            cellClassName: 'engagement-rate',
            property: 'insights_engagement_rate',
            valueSortFunction: numericValueSort,
            valueFormat: formatter.formats.percentAbsolute,
            description: 'The percentage of unique users who saw this post (unique reach) and then engaged with it (unique engaged users).'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_49',
            semanticId: 'FACEBOOK_INSIGHTS_POST_ENGAGED_USERS',
            name: 'Engaged Users',
            valueFormat: formatter.formats.abbreviated,
            property: 'facebook_insights_data.post_engaged_users',
            description: getFacebookInsightsPostPropertyDisplayString('post_engaged_users')
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_50',
            semanticId: 'FACEBOOK_INSIGHTS_POST_ENGAGED_FANS',
            name: 'Page Fans',
            valueFormat: formatter.formats.abbreviated,
            columnName: createColumnNameRenderer('Engaged <%- name %>'),
            description: 'The number of page fans that engaged with your post. Engagement includes clicks, reactions, comments, and shares.',
            property: 'facebook_insights_data.post_engaged_fan'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_51',
            semanticId: 'FACEBOOK_INSIGHTS_POST_ENGAGED_USERS_OTHER',
            name: 'Other',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.abbreviated),
            columnName: reverseHierarchyColumnNameRenderer,
            description: `The number of people who aren't page fans that engaged with your post. Engagement includes clicks, reactions, comments, and shares.`,
            valueSortFunction: numericValueSort,
            sortKey: 'engaged_users_other',
            property: 'engaged_users_other'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_122',
            semanticId: 'FACEBOOK_INSIGHTS_POST_CONSUMPTIONS',
            name: 'Consumptions via Insights',
            valueFormat: formatter.formats.abbreviated,
            property: 'facebook_insights_data.post_consumptions',
            description: 'The consumptions (total, non-unique) data for this post as reported by Facebook Insights.'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_123',
            semanticId: 'FACEBOOK_INSIGHTS_POST_CONSUMPTIONS_LINK_CLICKS',
            className: 'link-clicks',
            default: 0,
            name: 'Link Clicks',
            columnName: viaInsightsNameRenderer,
            valueFormat: formatter.formats.abbreviated,
            description: 'The total number of clicks on a link in your post as reported by Facebook Insights.',
            property: 'facebook_insights_data.post_consumptions_by_type.link clicks',
            propertyAlias: 'alias.post_consumptions_by_type.link_clicks'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_124',
            semanticId: 'FACEBOOK_INSIGHTS_POST_CONSUMPTIONS_PHOTO_VIEWS',
            className: 'photo-views',
            default: 0,
            name: 'Photo Views',
            columnName: viaInsightsNameRenderer,
            valueFormat: formatter.formats.abbreviated,
            description: 'The total number of clicks to view a photo in your post as reported by Facebook Insights.',
            property: 'facebook_insights_data.post_consumptions_by_type.photo view',
            propertyAlias: 'alias.post_consumptions_by_type.photo_view'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_125',
            semanticId: 'FACEBOOK_INSIGHTS_POST_CONSUMPTIONS_VIDEO_PLAYS',
            className: 'video-plays',
            default: 0,
            name: 'Video Plays',
            columnName: viaInsightsNameRenderer,
            valueFormat: formatter.formats.abbreviated,
            description: 'The total number of clicks to view a video in your post as reported by Facebook Insights.',
            property: 'facebook_insights_data.post_consumptions_by_type.video play',
            propertyAlias: 'alias.post_consumptions_by_type.video_play'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: `facebook_post_metric_${FACEBOOK_INSIGHTS_POSTS_SEED++}`,
            semanticId: 'FACEBOOK_INSIGHTS_POST_CONSUMPTIONS_AUTO_PLAY_VIDEO_PLAYS',
            default: 0,
            name: 'Auto Play',
            valueFormat: formatter.formats.abbreviated,
            description: 'The unique number of users who view a video in your post with auto-play.',
            property: 'facebook_insights_data.post_video_views_autoplayed'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: `facebook_post_metric_${FACEBOOK_INSIGHTS_POSTS_SEED++}`,
            semanticId: 'FACEBOOK_INSIGHTS_POST_CONSUMPTIONS_CLICK_TO_PLAY_VIDEO_PLAYS',
            default: 0,
            name: 'Click to Play',
            valueFormat: formatter.formats.abbreviated,
            description: 'The unique number of users who view a video in your post with click to play.',
            property: 'facebook_insights_data.post_video_views_clicked_to_play'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: `facebook_post_metric_${FACEBOOK_INSIGHTS_POSTS_SEED++}`,
            semanticId: 'FACEBOOK_INSIGHTS_POST_CONSUMPTIONS_SOUND_ON_VIDEO_PLAYS',
            default: 0,
            name: 'Sound On',
            valueFormat: formatter.formats.abbreviated,
            description: 'The unique number of users who view a video in your post with sound on.',
            property: 'facebook_insights_data.post_video_views_sound_on'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: `facebook_post_metric_${FACEBOOK_INSIGHTS_POSTS_SEED++}`,
            semanticId: 'FACEBOOK_INSIGHTS_POST_CONSUMPTIONS_SOUND_OFF_VIDEO_PLAYS',
            default: 0,
            name: 'Sound Off',
            valueFormat: formatter.formats.abbreviated,
            description: 'The unique number of users who view a video in your post with sound off.',
            property: 'facebook_insights_data.post_video_views - facebook_insights_data.post_video_views_sound_on'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_126',
            semanticId: 'FACEBOOK_INSIGHTS_POST_CONSUMPTIONS_OTHER_CLICKS',
            className: 'other-clicks',
            default: 0,
            name: 'Other Clicks',
            columnName: viaInsightsNameRenderer,
            valueFormat: formatter.formats.abbreviated,
            description: 'The total number of clicks in your post (outside of to view a photo, video, or link) as reported by Facebook Insights.',
            property: 'facebook_insights_data.post_consumptions_by_type.other clicks',
            propertyAlias: 'alias.post_consumptions_by_type.other_clicks'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_58',
            semanticId: 'FACEBOOK_INSIGHTS_POST_ENGAGEMENT_TOTAL',
            name: 'Social Engagement Total, Post-only',
            property: 'engagement_total',
            valueFormat: formatter.formats.abbreviated,
            description: strings.facebook_insights_post_post_only_social_engagement_total_description
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_59',
            semanticId: 'FACEBOOK_INSIGHTS_POST_REACTIONS',
            className: 'reactions',
            default: 0,
            name: 'Reactions, Post-only',
            columnName: 'Reactions on Post',
            property: 'reactions',
            valueFormat: formatter.formats.abbreviated,
            description: strings.facebook_insights_post_post_only_reactions_description
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_60',
            semanticId: 'FACEBOOK_INSIGHTS_POST_COMMENTS',
            className: 'comments',
            default: 0,
            name: 'Comments, Post-only',
            columnName: 'Comments on Post',
            property: 'comments',
            valueFormat: formatter.formats.abbreviated,
            description: strings.facebook_insights_post_post_only_comments_description
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_61',
            semanticId: 'FACEBOOK_INSIGHTS_POST_SHARES',
            className: 'shares',
            default: 0,
            name: 'Shares, Post-only',
            columnName: 'Shares on Post',
            property: 'shares',
            valueFormat: formatter.formats.abbreviated,
            description: strings.facebook_insights_post_post_only_shares_description
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_70',
            semanticId: 'FACEBOOK_INSIGHTS_POST_TOTAL_REACTIONS',
            name: 'Total Reactions',
            property: 'total_reactions',
            valueFormat: formatter.formats.abbreviated,
            description: strings.facebook_insights_post_story_reactions
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_71',
            semanticId: 'FACEBOOK_INSIGHTS_POST_REACTIONS_LIKE',
            default: 0,
            name: 'Likes',
            columnName: createColumnNameRenderer('Like Reactions'),
            property: 'facebook_insights_data.post_reactions_by_type_total.like',
            valueFormat: formatter.formats.abbreviated,
            description: strings.facebook_insights_post_like_reactions,
            iconUrl: '/images/reactions/like.png'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_72',
            semanticId: 'FACEBOOK_INSIGHTS_POST_REACTIONS_LOVE',
            default: 0,
            name: 'Loves',
            columnName: createColumnNameRenderer('Love Reactions'),
            property: 'facebook_insights_data.post_reactions_by_type_total.love',
            valueFormat: formatter.formats.abbreviated,
            description: strings.facebook_insights_post_love_reactions,
            iconUrl: '/images/reactions/love.png'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_73',
            semanticId: 'FACEBOOK_INSIGHTS_POST_REACTIONS_HAHA',
            default: 0,
            name: 'Hahas',
            columnName: createColumnNameRenderer('Haha Reactions'),
            property: 'facebook_insights_data.post_reactions_by_type_total.haha',
            valueFormat: formatter.formats.abbreviated,
            description: strings.facebook_insights_post_haha_reactions,
            iconUrl: '/images/reactions/haha.png'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_74',
            semanticId: 'FACEBOOK_INSIGHTS_POST_REACTIONS_WOW',
            default: 0,
            name: 'Wows',
            columnName: createColumnNameRenderer('Wow Reactions'),
            property: 'facebook_insights_data.post_reactions_by_type_total.wow',
            valueFormat: formatter.formats.abbreviated,
            description: strings.facebook_insights_post_wow_reactions,
            iconUrl: '/images/reactions/wow.png'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_75',
            semanticId: 'FACEBOOK_INSIGHTS_POST_REACTIONS_SORRY',
            default: 0,
            name: 'Sads',
            columnName: createColumnNameRenderer('Sad Reactions'),
            property: 'facebook_insights_data.post_reactions_by_type_total.sorry',
            valueFormat: formatter.formats.abbreviated,
            description: strings.facebook_insights_post_sad_reactions,
            iconUrl: '/images/reactions/sad.png'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_76',
            semanticId: 'FACEBOOK_INSIGHTS_POST_REACTIONS_ANGRY',
            default: 0,
            name: 'Angrys',
            columnName: createColumnNameRenderer('Angry Reactions'),
            property: 'facebook_insights_data.post_reactions_by_type_total.anger',
            valueFormat: formatter.formats.abbreviated,
            description: strings.facebook_insights_post_angry_reactions,
            iconUrl: '/images/reactions/angry.png'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_66',
            semanticId: 'FACEBOOK_INSIGHTS_POST_AND_SHARES_ENGAGEMENT_TOTAL',
            name: 'Social Engagement Total',
            property: 'facebook_insights_data.post_stories',
            valueFormat: formatter.formats.abbreviated,
            description: strings.facebook_insights_post_stories
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_67',
            semanticId: 'FACEBOOK_INSIGHTS_POST_AND_SHARES_REACTIONS',
            default: 0,
            name: 'Total Reactions',
            columnName: 'Reactions on Post and Shares',
            abbreviatedName: 'Reactions',
            property: 'total_reactions',
            className: 'reactions',
            valueFormat: formatter.formats.abbreviated,
            description: strings.facebook_insights_post_story_reactions
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_68',
            semanticId: 'FACEBOOK_INSIGHTS_POST_AND_SHARES_COMMENTS',
            default: 0,
            name: 'Comments',
            columnName: createColumnNameRenderer('<%- name %> on Post and Shares'),
            property: 'facebook_insights_data.post_stories_by_action_type.comment',
            className: 'comments',
            valueFormat: formatter.formats.abbreviated,
            description: strings.facebook_insights_post_comments_description
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_69',
            semanticId: 'FACEBOOK_INSIGHTS_POST_AND_SHARES_SHARES',
            default: 0,
            name: 'Shares',
            columnName: createColumnNameRenderer('<%- name %> on Post and Shares'),
            property: 'facebook_insights_data.post_stories_by_action_type.share',
            className: 'shares',
            valueFormat: formatter.formats.abbreviated,
            description: strings.facebook_insights_post_shares_description
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_104',
            semanticId: 'FACEBOOK_INSIGHTS_POST_ORGANIC_CONSUMPTIONS',
            name: 'Consumptions (Organic)',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.abbreviated),
            valueSortFunction: numericValueSort,
            property: 'post_consumptions_organic' // TODO: The math isn't working out so well here.
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_105',
            semanticId: 'FACEBOOK_INSIGHTS_POST_ORGANIC_LINK_CLICKS',
            name: 'Organic Link Clicks',
            abbreviatedName: 'Link Clicks',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.abbreviated),
            valueSortFunction: numericValueSort,
            property: 'link_clicks_organic',
            description: 'TODO'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_106',
            semanticId: 'FACEBOOK_INSIGHTS_POST_ORGANIC_PHOTO_VIEWS',
            name: 'Organic Photo Views',
            abbreviatedName: 'Photo Views',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.abbreviated),
            valueSortFunction: numericValueSort,
            property: 'photo_views_organic',
            description: 'TODO'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_107',
            semanticId: 'FACEBOOK_INSIGHTS_POST_ORGANIC_VIDEO_PLAYS',
            name: 'Organic Video Plays',
            abbreviatedName: 'Video Plays',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.abbreviated),
            valueSortFunction: numericValueSort,
            property: 'video_plays_organic',
            description: 'TODO'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_109',
            semanticId: 'FACEBOOK_INSIGHTS_POST_ORGANIC_ENGAGEMENT',
            name: 'Social Engagement Total, Organic',
            className: 'organic',
            property: 'engagement_organic',
            valueSortFunction: numericValueSort,
            redactIfUnderReporting: true,
            valueFormat: formatter.falsyDataWrapper(formatter.formats.abbreviated),
            description: 'The lifetime total social engagement (reactions, comments, shares) from users who viewed this post because of organic reach (including viral).'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            semanticId: 'FACEBOOK_INSIGHTS_POST_ORGANIC_ENGAGEMENT_RATE',
            omit: false,
            name: 'Engagement Rate (Organic)',
            className: 'organic',
            property: 'engagement_rate_organic',
            redactIfUnderReporting: true,
            valueFormat: formatter.falsyDataWrapper(formatter.formats.percentAbsolute),
            description: 'The total social engagement (reactions, comments, shares) from users who viewed this post organically, divided by the unique organic reach (including viral reach).'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_110',
            semanticId: 'FACEBOOK_INSIGHTS_POST_ORGANIC_REACTIONS',
            default: 0,
            name: 'Reactions',
            columnName: organicColumnNameRenderer,
            property: 'reactions_organic',
            className: 'reactions',
            redactIfUnderReporting: true,
            valueSortFunction: numericValueSort,
            valueFormat: formatter.falsyDataWrapper(formatter.formats.abbreviated),
            description: 'The lifetime total reactions from users who viewed this post because of organic reach.'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_111',
            semanticId: 'FACEBOOK_INSIGHTS_POST_ORGANIC_COMMENTS',
            default: 0,
            name: 'Comments',
            columnName: organicColumnNameRenderer,
            property: 'comments_organic',
            className: 'comments',
            redactIfUnderReporting: true,
            valueFormat: formatter.falsyDataWrapper(formatter.formats.abbreviated),
            valueSortFunction: numericValueSort,
            description: 'The lifetime total comments from users who viewed this post because of organic reach.'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_112',
            semanticId: 'FACEBOOK_INSIGHTS_POST_ORGANIC_SHARES',
            default: 0,
            name: 'Shares',
            columnName: organicColumnNameRenderer,
            property: 'shares_organic',
            className: 'shares',
            redactIfUnderReporting: true,
            valueFormat: formatter.falsyDataWrapper(formatter.formats.abbreviated),
            valueSortFunction: numericValueSort,
            description: 'The lifetime total shares from users who viewed this post because of organic reach.'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_113',
            semanticId: 'FACEBOOK_INSIGHTS_POST_PAID_CONSUMPTIONS',
            name: 'Consumptions via Ads',
            valueFormat: formatter.formats.abbreviated,
            valueSortFunction: numericValueSort,
            property: 'post_consumptions_paid',
            description: 'The consumptions (total, non-unique) data for this post as reported by Facebook Ads.'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_114',
            semanticId: 'FACEBOOK_INSIGHTS_POST_PAID_LINK_CLICKS',
            className: 'link-clicks',
            default: 0,
            name: 'Link Clicks',
            abbreviatedName: 'Link Clicks',
            columnName: viaAdsNameRenderer,
            valueFormat: formatter.formats.abbreviated,
            property: 'link_clicks_paid',
            description: 'The total number of clicks on a link in your post as reported by Facebook Ads.'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            semanticId: 'FACEBOOK_INSIGHTS_POST_PAID_OTHER_CLICKS',
            className: 'other-clicks',
            default: 0,
            name: 'Other Clicks',
            abbreviatedName: 'Other Clicks',
            columnName: viaAdsNameRenderer,
            valueFormat: formatter.formats.abbreviated,
            property: 'other_clicks_paid',
            description: 'The total number of clicks in your post (outside of to view a photo, video, or link) as reported by Facebook Ads.'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_115',
            semanticId: 'FACEBOOK_INSIGHTS_POST_PAID_PHOTO_VIEWS',
            className: 'photo-views',
            default: 0,
            name: 'Photo Views',
            abbreviatedName: 'Photo Views',
            columnName: viaAdsNameRenderer,
            valueFormat: formatter.formats.abbreviated,
            property: 'photo_views_paid',
            description: 'The total number of clicks to view a photo in your post as reported by Facebook Ads.'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_116',
            semanticId: 'FACEBOOK_INSIGHTS_POST_PAID_VIDEO_PLAYS',
            className: 'video-plays',
            default: 0,
            name: 'Video Plays',
            abbreviatedName: 'Video Plays',
            columnName: viaAdsNameRenderer,
            valueFormat: formatter.formats.abbreviated,
            property: 'video_plays_paid',
            description: 'The total number of clicks to view a video in your post as reported by Facebook Ads.'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_118',
            semanticId: 'FACEBOOK_INSIGHTS_POST_PAID_ENGAGEMENT',
            name: 'Social Engagement Total, Paid',
            className: 'paid',
            property: 'engagement_paid',
            valueFormat: formatter.formats.abbreviated,
            description: 'The lifetime total social engagement (reactions, comments, shares) from users who viewed this post because of paid reach.'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            semanticId: 'FACEBOOK_INSIGHTS_POST_PAID_ENGAGEMENT_RATE',
            omit: false,
            name: 'Engagement Rate (Paid)',
            className: 'paid',
            property: 'engagement_rate_paid',
            valueFormat: formatter.formats.percentAbsolute,
            description: 'TODO'
        },

        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_119',
            semanticId: 'FACEBOOK_INSIGHTS_POST_PAID_REACTIONS',
            default: 0,
            name: 'Reactions',
            columnName: paidColumnNameRenderer,
            property: 'reactions_paid',
            className: 'reactions',
            valueFormat: formatter.formats.abbreviated,
            description: 'The lifetime total reactions from users who viewed this post because of paid reach.'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_120',
            semanticId: 'FACEBOOK_INSIGHTS_POST_PAID_COMMENTS',
            default: 0,
            name: 'Comments',
            columnName: paidColumnNameRenderer,
            property: 'comments_paid',
            className: 'comments',
            valueFormat: formatter.formats.abbreviated,
            description: 'The lifetime total comments from users who viewed this post because of paid reach.'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_121',
            semanticId: 'FACEBOOK_INSIGHTS_POST_PAID_SHARES',
            default: 0,
            name: 'Shares',
            columnName: paidColumnNameRenderer,
            property: 'shares_paid',
            className: 'shares',
            valueFormat: formatter.formats.abbreviated,
            description: 'The lifetime total shares from users who viewed this post because of paid reach.'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_45',
            semanticId: 'FACEBOOK_INSIGHTS_POST_TOTAL_REACH',
            name: 'Total Reach',
            description: strings.facebook_insights_page_posts_impressions_unique_description,
            property: 'facebook_insights_data.post_impressions_unique',
            reachType: reachType.TOTAL
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_46',
            semanticId: 'FACEBOOK_INSIGHTS_POST_ORGANIC_REACH',
            name: 'Organic',
            className: 'organic',
            valueFormat: formatter.formats.abbreviated,
            columnName: createColumnNameRenderer('<%- name %> Reach'),
            description: strings.facebook_insights_page_posts_impressions_organic_unique_description,
            property: 'facebook_insights_data.post_impressions_organic_unique',
            reachType: reachType.ORGANIC
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_47',
            semanticId: 'FACEBOOK_INSIGHTS_POST_PAID_REACH',
            name: 'Paid',
            className: 'paid',
            valueFormat: formatter.formats.abbreviated,
            columnName: createColumnNameRenderer('<%- name %> Reach'),
            description: strings.facebook_insights_page_posts_impressions_paid_unique_description,
            property: 'facebook_insights_data.post_impressions_paid_unique',
            reachType: reachType.PAID
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_48',
            semanticId: 'FACEBOOK_INSIGHTS_POST_VIRAL_REACH',
            name: 'Organic, Viral',
            className: 'viral',
            valueFormat: formatter.formats.abbreviated,
            columnName: createColumnNameRenderer('<%- name %> Reach'),
            description: strings.facebook_insights_page_posts_impressions_viral_unique_description,
            property: 'facebook_insights_data.post_impressions_viral_unique',
            reachType: reachType.VIRAL
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            semanticId: 'FACEBOOK_INSIGHTS_POST_ORGANIC_TOTAL_REACH',
            name: 'Organic',
            className: 'organic',
            valueFormat: formatter.formats.abbreviated,
            columnName: createColumnNameRenderer('<%- name %> Total Reach'),
            property: 'total_reach_organic',
            reachType: reachType.ORGANIC,
            description: 'TODO'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_62',
            semanticId: 'FACEBOOK_INSIGHTS_POST_TOTAL_IMPRESSIONS',
            name: 'Total Impressions',
            valueFormat: formatter.formats.abbreviated,
            property: 'facebook_insights_data.post_impressions',
            description: strings.facebook_insights_posts_impressions_description,
            reachType: reachType.TOTAL
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_63',
            semanticId: 'FACEBOOK_INSIGHTS_POST_ORGANIC_IMPRESSIONS',
            name: 'Organic',
            className: 'organic',
            valueFormat: formatter.formats.abbreviated,
            columnName: createColumnNameRenderer('<%- name %> Impressions'),
            description: strings.facebook_insights_posts_organic_impressions_description,
            property: 'facebook_insights_data.post_impressions_organic',
            reachType: reachType.ORGANIC
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_64',
            semanticId: 'FACEBOOK_INSIGHTS_POST_PAID_IMPRESSIONS',
            name: 'Paid',
            className: 'paid',
            valueFormat: formatter.formats.abbreviated,
            columnName: createColumnNameRenderer('<%- name %> Impressions'),
            property: 'facebook_insights_data.post_impressions_paid',
            description: strings.facebook_insights_posts_paid_impressions_description,
            reachType: reachType.PAID
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_128',
            semanticId: 'FACEBOOK_INSIGHTS_POST_NONVIRAL_IMPRESSIONS',
            name: 'Organic, Non-Viral',
            className: 'organic',
            valueFormat: formatter.formats.abbreviated,
            columnName: createColumnNameRenderer('<%- name %> Impressions'),
            property: 'facebook_insights_data.post_impressions_nonviral',
            description: strings.facebook_insights_posts_nonviral_impressions_description,
            reachType: reachType.NONVIRAL
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_52',
            semanticId: 'FACEBOOK_INSIGHTS_POST_FAN_REACH',
            omit: false,
            name: 'Fan Reach',
            valueFormat: formatter.formats.abbreviated,
            property: 'facebook_insights_data.post_fan_reach',
            description: 'The percentage of your page fans that saw this post.'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_83',
            semanticId: 'FACEBOOK_INSIGHTS_POST_VIDEO_AVG_WATCH_LENGTH',
            name: 'Avg. Watch Length',
            valueFormat: formatter.falsyDataWrapper(formatter.formatTimeInterval),
            property: 'facebook_insights_data.post_video_avg_time_watched',
            description: getFacebookInsightsPostPropertyDisplayString('post_video_avg_time_watched')
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_84',
            semanticId: 'FACEBOOK_INSIGHTS_POST_VIDEO_LENGTH',
            name: 'Length',
            property: 'facebook_insights_data.post_video_length',
            valueFormat: formatter.falsyDataWrapper(formatter.formatTimeInterval),
            description: getFacebookInsightsPostPropertyDisplayString('post_video_length'),
            columnName: createColumnNameRenderer('Video <%- name %>')
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_85',
            semanticId: 'FACEBOOK_INSIGHTS_POST_VIDEO_AVG_PERCENT_VIEWED',
            name: '% Viewed',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.percentAbsolute),
            description: 'The percentage of the video that your average viewer watched.',
            columnName: createColumnNameRenderer('<%- name %> of Video'),
            valueSortFunction: numericValueSort,
            sortKey: 'avg_watch_length_pct_viewed',
            property: 'avg_watch_length_pct_viewed'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_86',
            semanticId: 'FACEBOOK_INSIGHTS_POST_TOTAL_VIDEO_VIEWS',
            name: 'Total Video Views',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.abbreviated),
            property: 'facebook_insights_data.post_video_views',
            description: getFacebookInsightsPostPropertyDisplayString('post_video_views')
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_87',
            semanticId: 'FACEBOOK_INSIGHTS_POST_ORGANIC_VIDEO_VIEWS',
            name: 'Organic',
            className: 'organic',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.abbreviated),
            description: getFacebookInsightsPostPropertyDisplayString('post_video_views_organic'),
            property: 'facebook_insights_data.post_video_views_organic',
            columnName: createColumnNameRenderer('<%- name %> Video Views')
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_88',
            semanticId: 'FACEBOOK_INSIGHTS_POST_PAID_VIDEO_VIEWS',
            name: 'Paid',
            className: 'paid',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.abbreviated),
            property: 'facebook_insights_data.post_video_views_paid',
            description: getFacebookInsightsPostPropertyDisplayString('post_video_views_paid'),
            columnName: createColumnNameRenderer('<%- name %> Video Views')
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            semanticId: 'FACEBOOK_INSIGHTS_POST_TOTAL_VIDEO_10_SECOND_VIEWS',
            default: 0,
            name: '10-Second Views',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.abbreviated),
            property: 'facebook_insights_data.post_video_views_10s',
            description: getFacebookInsightsPostPropertyDisplayString('post_video_views_10s')
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            semanticId: 'FACEBOOK_INSIGHTS_POST_TOTAL_VIDEO_10_SECOND_VIEWS_PERCENT',
            default: 0,
            name: '10-Second Views',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.percentAbsolute),
            property: 'total_video_10_second_views_percent',
            description: getFacebookInsightsPostPropertyDisplayString('post_video_views_10s')
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            semanticId: 'FACEBOOK_INSIGHTS_POST_ORGANIC_VIDEO_10_SECOND_VIEWS',
            default: 0,
            name: 'Organic',
            className: 'organic',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.abbreviated),
            property: 'facebook_insights_data.post_video_views_10s_organic',
            description: getFacebookInsightsPostPropertyDisplayString('post_video_views_10s_organic')
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            semanticId: 'FACEBOOK_INSIGHTS_POST_PAID_VIDEO_10_SECOND_VIEWS',
            default: 0,
            name: 'Paid',
            className: 'paid',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.abbreviated),
            property: 'facebook_insights_data.post_video_views_10s_paid',
            description: getFacebookInsightsPostPropertyDisplayString('post_video_views_10s_paid')
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_89',
            semanticId: 'FACEBOOK_INSIGHTS_POST_TOTAL_VIDEO_30_SECOND_VIEWS',
            name: '30-Second Views',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.abbreviated),
            property: 'facebook_insights_data.post_video_complete_views_30s',
            description: getFacebookInsightsPostPropertyDisplayString('post_video_complete_views_30s')
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            semanticId: 'FACEBOOK_INSIGHTS_POST_TOTAL_VIDEO_30_SECOND_VIEWS_PERCENT',
            name: '30-Second Views',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.percentAbsolute),
            property: 'total_video_30_second_views_percent',
            description: getFacebookInsightsPostPropertyDisplayString('post_video_complete_views_30s')
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_90',
            semanticId: 'FACEBOOK_INSIGHTS_POST_ORGANIC_VIDEO_30_SECOND_VIEWS',
            name: 'Organic',
            className: 'organic',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.abbreviated),
            description: getFacebookInsightsPostPropertyDisplayString('post_video_complete_views_30s_organic'),
            property: 'facebook_insights_data.post_video_complete_views_30s_organic',
            columnName: reverseHierarchyColumnNameRenderer
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_91',
            semanticId: 'FACEBOOK_INSIGHTS_POST_PAID_VIDEO_30_SECOND_VIEWS',
            name: 'Paid',
            className: 'paid',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.abbreviated),
            description: getFacebookInsightsPostPropertyDisplayString('post_video_complete_views_30s_paid'),
            property: 'facebook_insights_data.post_video_complete_views_30s_paid',
            columnName: reverseHierarchyColumnNameRenderer
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_92',
            semanticId: 'FACEBOOK_INSIGHTS_POST_TOTAL_VIDEO_30_SECOND_VIEW_RATE',
            name: '30-Second View Rate',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.percentAbsolute),
            valueSortFunction: numericValueSort,
            sortKey: '30_second_view_rate',
            property: '30_second_view_rate',
            description: 'The percentage of your video viewers who made it to the 30-second point or the end, whichever comes first.'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_93',
            semanticId: 'FACEBOOK_INSIGHTS_POST_ORGANIC_VIDEO_30_SECOND_VIEW_RATE',
            name: 'Organic',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.percentAbsolute),
            description: 'The percentage of your organic video viewers who made it to the 30-second point or the end, whichever comes first.',
            columnName: reverseHierarchyColumnNameRenderer,
            valueSortFunction: numericValueSort,
            sortKey: '30_second_view_rate_organic',
            property: '30_second_view_rate_organic'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_94',
            semanticId: 'FACEBOOK_INSIGHTS_POST_PAID_VIDEO_30_SECOND_VIEW_RATE',
            name: 'Paid',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.percentAbsolute),
            description: 'The percentage of your paid video viewers who made it to the 30-second point or the end, whichever comes first.',
            columnName: reverseHierarchyColumnNameRenderer,
            valueSortFunction: numericValueSort,
            sortKey: '30_second_view_rate_paid',
            property: '30_second_view_rate_paid'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_95',
            semanticId: 'FACEBOOK_INSIGHTS_POST_TOTAL_VIDEO_95_PERCENT_VIEWS',
            name: 'Views to 95%',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.abbreviated),
            valueSortFunction: numericValueSort,
            sortKey: 'views_to_95_pct',
            property: 'views_to_95_pct',
            description: 'The number of times your video was viewed to 95% of its length, including views that skipped to this point.'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_96',
            semanticId: 'FACEBOOK_INSIGHTS_POST_ORGANIC_VIDEO_95_PERCENT_VIEWS',
            name: 'Organic',
            className: 'organic',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.abbreviated),
            description: getFacebookInsightsPostPropertyDisplayString('post_video_complete_views_organic_unique'),
            columnName: reverseHierarchyColumnNameRenderer,
            property: 'facebook_insights_data.post_video_complete_views_organic'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_97',
            semanticId: 'FACEBOOK_INSIGHTS_POST_PAID_VIDEO_95_PERCENT_VIEWS',
            name: 'Paid',
            className: 'paid',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.abbreviated),
            description: getFacebookInsightsPostPropertyDisplayString('post_video_complete_views_paid_unique'),
            columnName: reverseHierarchyColumnNameRenderer,
            property: 'facebook_insights_data.post_video_complete_views_paid'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_98',
            semanticId: 'FACEBOOK_INSIGHTS_POST_TOTAL_VIDEO_95_PERCENT_VIEW_RATE',
            name: '95% View Rate',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.percentAbsolute),
            valueSortFunction: numericValueSort,
            sortKey: '95_pct_view_rate',
            property: '95_pct_view_rate',
            description: 'The percentage of your video viewers that viewed to 95% of its length, including views that skipped to this point.'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_99',
            semanticId: 'FACEBOOK_INSIGHTS_POST_ORGANIC_VIDEO_95_PERCENT_VIEW_RATE',
            name: 'Organic',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.percentAbsolute),
            description: 'The percentage of your organic video viewers that viewed to 95% of its length, including views that skipped to this point.',
            columnName: reverseHierarchyColumnNameRenderer,
            valueSortFunction: numericValueSort,
            sortKey: '95_pct_view_rate_organic',
            property: '95_pct_view_rate_organic'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            semanticId: 'FACEBOOK_INSIGHTS_POST_PAID_VIDEO_95_PERCENT_VIEW_RATE',
            name: 'Paid',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.percentAbsolute),
            description: 'The percentage of your paid video viewers that viewed to 95% of its length, including views that skipped to this point.',
            columnName: reverseHierarchyColumnNameRenderer,
            valueSortFunction: numericValueSort,
            sortKey: '95_pct_view_rate_paid',
            property: '95_pct_view_rate_paid'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            semanticId: 'FACEBOOK_INSIGHTS_POST_LIVE_VIDEO_VIEWS',
            name: 'Unique Live Viewers',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.abbreviated),
            description: 'The unique number of users who view a video in your post live.',
            sort: numericValueSort(function (post) {
                return _.get(post, ['video_data', 'live_audience_count']);
            }),
            property: 'video_data.live_audience_count'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            semanticId: 'FACEBOOK_INSIGHTS_POST_WAS_LIVE_VIDEO',
            default: false,
            name: 'Was Live Video',
            description: 'Was the video of this post once a live video.',
            property: 'was_live_video'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            semanticId: 'FACEBOOK_INSIGHTS_POST_ADMIN_CREATOR_NAME',
            name: 'Posted By',
            description: 'The name of the admin creator of this post.',
            property: 'admin_creator_name',
            valueFormat: formatter.falsyDataWrapper(_.identity)
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            semanticId: 'FACEBOOK_INSIGHTS_SHARES_ENGAGEMENT_TOTAL',
            name: 'Engagement on Shares',
            property: 'fb_insights_shared_engagement_total',
            redactIfUnderReporting: true,
            valueFormat: formatter.formats.abbreviated,
            description: 'TODO'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            semanticId: 'FACEBOOK_INSIGHTS_POST_PERCENT_OF_ENGAGEMENT',
            name: 'Percent of Engagement',
            property: 'fb_insights_post_percent_of_engagement',
            redactIfUnderReporting: true,
            valueFormat: formatter.formats.percentAbsolute,
            description: 'TODO'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            semanticId: 'FACEBOOK_INSIGHTS_VIDEO_VIEW_RATE',
            name: 'Video view rate',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.percentAbsolute),
            description: 'The total number of video views divided by the number of impressions the post received.',
            valueSortFunction: numericValueSort,
            sortKey: 'video_view_rate',
            property: 'video_view_rate'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            semanticId: 'FACEBOOK_INSIGHTS_SOCIAL_ENGAGEMENT_RATE',
            name: 'Social Engagement Rate',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.percentAbsolute),
            description: getFacebookInsightsPostPropertyDisplayString('post_detail_social_engagement_social_engagement_rate'),
            valueSortFunction: numericValueSort,
            sortKey: 'social_engagement_rate',
            property: 'social_engagement_rate'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            semanticId: 'FACEBOOK_INSIGHTS_POST_ADS_PAID_VIDEO_VIEWS',
            className: 'email-bucket',
            default: 0,
            name: 'Video Views',
            abbreviatedName: 'Video Views',
            columnName: viaAdsNameRenderer,
            valueFormat: formatter.formats.abbreviated,
            property: 'boosted_post_total_video_views',
            description: 'The total number of 3 second video videos on your post as reported by Facebook Ads.'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            semanticId: 'FACEBOOK_INSIGHTS_POST_ENGAGEMENT_RATE_BY_IMPRESSION',
            default: 0,
            name: 'Engagement Rate by Impression',
            abbreviatedName: 'Engagement Rate by Impression',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.percentAbsolute),
            property: 'engagement_rate_by_impression',
            description: strings.facebook_insights_post_engagement_rate_by_impression_description
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_65',
            semanticId: 'FACEBOOK_INSIGHTS_POST_VIRAL_IMPRESSIONS',
            name: 'Organic, Viral',
            className: 'viral',
            valueFormat: formatter.formats.abbreviated,
            columnName: createColumnNameRenderer('<%- name %> Impressions'),
            property: 'facebook_insights_data.post_impressions_viral',
            description: strings.facebook_insights_posts_viral_impressions_description,
            reachType: reachType.VIRAL
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_127',
            semanticId: 'FACEBOOK_INSIGHTS_POST_NONVIRAL_REACH',
            name: 'Organic, Non-Viral',
            className: 'organic',
            valueFormat: formatter.formats.abbreviated,
            columnName: createColumnNameRenderer('<%- name %> Reach'),
            description: strings.facebook_insights_page_posts_impressions_viral_unique_description,
            property: 'facebook_insights_data.post_impressions_nonviral_unique',
            reachType: reachType.NONVIRAL
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_128',
            semanticId: 'FACEBOOK_INSIGHTS_POST_VIDEO_VIEW_TIME',
            name: 'Total Watch Length',
            valueFormat: formatter.falsyDataWrapper(formatter.formatTimeInterval),
            description: getFacebookInsightsPostPropertyDisplayString('post_video_view_time'),
            property: 'facebook_insights_data.post_video_view_time'
        },
        {
            id: FACEBOOK_INSIGHTS_POSTS_SEED++,
            previousId: 'facebook_post_metric_129',
            semanticId: 'FACEBOOK_INSIGHTS_POST_ENGAGEMENT_RATE_BY_PRESENCE_REACH',
            name: 'Engagement Rate by Page Fan',
            valueFormat: formatter.falsyDataWrapper(formatter.formats.percentAbsolute),
            valueSortFunction: numericValueSort,
            sortKey: 'engagement_rate_by_presence_reach',
            property: 'engagement_rate_by_presence_reach'
        }
    ];

    const propertyAliases = {};
    _.each(facebookInsightsPostDetailMetrics, function (metricDescription) {
        const alias = metricDescription.propertyAlias;
        const property = metricDescription.property;
        if (alias && property) {
            propertyAliases[property] = alias;
        }
    });

    _.each(facebookInsightsPostDetailMetrics, function (metricDescription) {
        pushMetric(metricsModels.FacebookInsightsPostDetails, _.extend(metricDescription, {
            source: source.FACEBOOK_INSIGHTS,
            dontShowInUi: true,
            propertyAliases: propertyAliases
        }));
    });


    // Creates a mapping directly between name and id.
    // This is needed by compareData but was moved out for load order
    // reasons
    // TODO this extra work is probably not necessary
    const nameMapping = _.reduce(metricDescriptions, function (memo, description, name) {
        memo[name] = description.id;
        return memo;
    }, {});

    function buildDescription(source, path) {
        const sourceDetails = enums.sourceDetails[source];

        const desc = {
            source: source,
            rollupSource: sourceDetails.trendKey
        };

        const searchPath = _.last(path).toLowerCase();

        const dimensionDefinition = _.find(sourceDetails.dimensionKeys, function (dimension) {

            return (searchPath === _.get(dimension, 'path', dimension).toLowerCase());
        });

        if (_.isObject(dimensionDefinition)) {

            _.defaults(desc, _.omit(dimensionDefinition, 'path'));
            _.defaults(desc, {
                abbreviatedName: desc.name
            });
        }

        switch (searchPath) {
            case 'organic':
            case 'organic search':
                desc.className = 'link-clicks';
                break;
            case 'direct':
            case '(none)':
                desc.className = 'video-plays';
                break;
            case 'referral':
                desc.className = 'photo-views';
                break;
            case 'paid':
            case 'paid search':
            case 'cpc':
                desc.className = 'other-clicks';
                break;
            case '(other)':
                desc.className = 'other-bucket';
                break;
            case 'email':
                desc.className = 'email-bucket';
                break;
            case 'social':
                desc.className = 'social-bucket';
                break;
            default:
                throw new Error(`unknown metric search path ${searchPath}`);
        }

        return desc;
    }

    function buildMetric(prefix, defaultAttrs, parent) {
        const name = _.last(prefix);
        const prop = prefix.concat('value');
        const sourceDetails = enums.sourceDetails[parent.source];
        const title = [sourceDetails.name, s.titleize(name)].join(' ');
        // NOTE these values are not uppercase because foreign metrics can be case sensitive
        const id = [sourceDetails.name].concat(_.without(prefix, 'submetrics')).join('_').replace(/ /g, '_');

        return _.extend({}, defaultAttrs, {
            id: id,
            semanticId: id,
            name: title,
            abbreviatedName: s.titleize(name),
            propSummary: prop,
            propDaily: prop,
            dimensionName: name,
            serverRollup: Boolean(parent.serverRollup),
            valueFormat: parent.format,
            format: parent.format,
            dataType: parent.dataType,
            dimensions: [name],
            property: _.head(prefix)
        }, buildDescription(parent.source, prefix));
    }

    function constructMetrics(prefix, metricData, parameters, defaultAttrs, parent) {
        const name = _.last(prefix);
        let metric = _.find(metricDescriptions, _.matchesProperty('property', name));

        if (!metric) {
            metric = buildMetric(prefix, defaultAttrs, parent);
        }

        if (parameters) {
            const param = _.findKey(parameters, function (values) {
                return _.includes(_.keys(values), name);
            });

            if (param) {
                metric.parameters = _.extend({}, (parent ? parent.parameters : {}));
                metric.parameters[param] = name;

                parameters = parameters[param][name];
            }
        }

        if (metricData && metricData.submetrics) {
            // NOTE take the union of dimensionKeys so that future requests do
            // not clobber it
            metric.dimensionKeys = _.union(metric.dimensionKeys, _.map(metricData.submetrics, function (submetricData, submetric) {
                const subPrefix = prefix.concat('submetrics', submetric);
                return constructMetrics(subPrefix, submetricData, parameters, defaultAttrs, metric).id;
            }));
        }

        return metric;
    }

    const buildMetrics = function (data, metricParameters, defaultAttrs) {

        return _.map(data, function (metricData, metric) {
            return constructMetrics([metric], metricData, metricParameters, defaultAttrs);
        });
    };

    metrics.mappings = metricMappings;
    metrics.id = nameMapping;
    metrics.descriptions = metricDescriptions;
    metrics.dataType = dataType;
    metrics.metricType = metricType;
    metrics.category = category;
    metrics.source = source;
    metrics.iconUrls = iconUrls;
    metrics.build = buildMetrics;
}
